import * as React from 'react';
import React__default, { useMemo, useState, useCallback, useEffect } from 'react';
import { ScrollIntoView, Alert, Button, RichTextArea, CheckboxList, MediaQuery, toast, Link, LoaderScreen, Flyout } from '@grandvisionhq/common';
import { uninitState, idleState, useSelector, useIntl, statusFailed, useDispatch, connect, withIntl, failedState, loadingState, successState, statusSuccess, statusLoading, useFeatureToggles, ReducersRegistry, SagaRegistry } from '@grandvisionhq/state';
import classnames from 'classnames';
import { Heading, Text, SkeletonLoader } from '@grandvisionhq/elements';
import * as swcHelpers from '@swc/helpers';
import isEmpty from 'lodash/isEmpty';
import { createBrowserHistory } from 'history';
import { gql, ApolloError, useQuery, useMutation } from '@grandvisionhq/graphql';
import { createSelector } from 'reselect';
import { LocaleUtils, parseHtml, QueryString, StringGuard, isString, isModifiedClickEvent } from '@grandvisionhq/utils';
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import { Form, Util, PasswordWithStrengthIndicator, Email, DateOfBirthSelect, Password } from '@grandvisionhq/forms';
import { takeLatest, select, call, put, takeLeading, all } from 'redux-saga/effects';
import { WebAuth } from 'auth0-js';
import { channel, buffers } from 'redux-saga';
import jwtDecode from 'jwt-decode';
import { Type, optional, verify } from 'specified';
import { DataLayer } from '@grandvisionhq/analytics';
import { Customers } from '@grandvisionhq/api-client';
import { Icon } from '@grandvisionhq/icons';

/** @deprecated use the new GQL hook use-opt-ins.ts */ const createOptInsUpdate = (optIns = {})=>{
    if (isEmpty(optIns)) {
        return undefined;
    }
    return Object.keys(optIns).reduce((m, optInName)=>swcHelpers.objectSpread({}, m, {
            [optInName]: {
                value: optIns[optInName].checked,
                uiType: 'checkbox',
                literalText: optIns[optInName].label
            }
        })
    , {});
};

const isGroupedOptin = (item)=>'groupedOptIns' in item
;
var FormName;
(function(FormName) {
    FormName["personalDetails"] = "personalDetails";
    FormName["billingAddress"] = "billingAddress";
    FormName["preferredStore"] = "preferredStore";
    FormName["signUp"] = "signUp";
})(FormName || (FormName = {}));

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isGroupedOptin: isGroupedOptin,
  get FormName () { return FormName; }
});

const getParsedDataFromLS = ()=>{
    try {
        const value = window.localStorage.getItem(FormName.personalDetails);
        if (value !== null && value !== 'undefined' && value !== '' && value.trim() !== '') {
            const returnValue = JSON.parse(value);
            if (typeof returnValue !== 'object') {
                return undefined;
            }
            if (Object.values(returnValue).some((v)=>typeof v !== 'string'
            )) {
                return undefined;
            }
            return returnValue;
        } else {
            return undefined;
        }
    } catch (error) {
        console.error(error);
    }
};
const writeUserDataToLS = (data)=>{
    try {
        window.localStorage.setItem(FormName.personalDetails, JSON.stringify(data));
    } catch (error) {
        console.error(error);
    }
};
const removeUserDataFromLS = ()=>{
    try {
        window.localStorage.removeItem(FormName.personalDetails);
    } catch (error) {
        console.error(error);
    }
};

const formatError = (error)=>{
    if (!error) {
        return '';
    }
    // TODO: remove this and parse the rules so we can use bloomreach labels to format them
    if ('policy' in error && error.policy === 'string') {
        return error.policy.split(/\*\s?/);
    }
    if ('description' in error) {
        if (typeof error.description === 'string') {
            return error.description;
        }
        if (typeof error.description === 'object' && error.description.rules) {
            return error.description.rules.map((r)=>r.message
            );
        }
    }
    if ('message' in error) {
        return error.message;
    }
    return '';
};

let _history;
const history = ()=>{
    if (!_history) {
        _history = createBrowserHistory();
    }
    return _history;
};

const parseAuth0StateParam = (state)=>{
    let isPasswordless = false;
    let email;
    try {
        if (typeof state === 'string') {
            const statePayload = JSON.parse(state);
            if (typeof statePayload === 'object' && 'type' in statePayload && 'email' in statePayload) {
                isPasswordless = statePayload.type === 'passwordless';
                email = statePayload.email;
            }
        }
    } catch (e) {}
    return {
        email,
        type: isPasswordless ? 'passwordless' : 'regular'
    };
};

// copied from auth0-js/src/helper/random.js
const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
function randomString(length) {
    const bytes = new Uint8Array(length);
    const result = [];
    const cryptoObj = // eslint-disable-next-line @typescript-eslint/dot-notation
    'msCrypto' in window ? window['msCrypto'] : window.crypto;
    if (!cryptoObj) {
        return null;
    }
    const random = cryptoObj.getRandomValues(bytes);
    for(let a = 0; a < random.length; a++){
        result.push(charset[random[a] % charset.length]);
    }
    return result.join('');
}

// Function needed to bypass IE11 'Invalid calling object' error
const redirect = (route)=>window && window.location.assign(route)
;

var AccountOrigination;
(function(AccountOrigination) {
    AccountOrigination["IN_STORE"] = "IN_STORE";
    AccountOrigination["ONLINE"] = "ONLINE";
})(AccountOrigination || (AccountOrigination = {}));
var AccountReason;
(function(AccountReason) {
    AccountReason["APPOINTMENT"] = "APPOINTMENT";
    AccountReason["ORDER"] = "ORDER";
    AccountReason["SIGN_UP"] = "SIGN_UP";
    AccountReason["SUBSCRIPTION"] = "SUBSCRIPTION";
})(AccountReason || (AccountReason = {}));
var AccountVerificationMethod;
(function(AccountVerificationMethod) {
    AccountVerificationMethod["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    AccountVerificationMethod["NONE"] = "NONE";
})(AccountVerificationMethod || (AccountVerificationMethod = {}));
var CreateAccountTargetAction;
(function(CreateAccountTargetAction) {
    CreateAccountTargetAction["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    CreateAccountTargetAction["SIGN_UP"] = "SIGN_UP";
})(CreateAccountTargetAction || (CreateAccountTargetAction = {}));
var UIType;
(function(UIType) {
    UIType["CHECKBOX"] = "CHECKBOX";
})(UIType || (UIType = {}));

function ungroupOptIns(optIns) {
    return optIns.flatMap((curr)=>isGroupedOptin(curr) ? curr.groupedOptIns : curr
    );
}
function omitGroupedOptIns(optIns) {
    return optIns.filter((optIn)=>!isGroupedOptin(optIn)
    );
}
const formatOptIns = (availableOptIns1, selectedOptIns1, getLabel)=>{
    const formatOptInsWithSelection = (availableOptIns, selectedOptIns)=>{
        const ungroupedAvailableOptins = ungroupOptIns(availableOptIns);
        const ungroupedSelectedOptins = ungroupOptIns(selectedOptIns);
        return ungroupedAvailableOptins.map((optIn)=>swcHelpers.objectSpread({}, optIn, {
                isSelected: ungroupedSelectedOptins.some((s)=>optIn.value === s.value
                )
            })
        );
    };
    const formatOptIn = (input)=>({
            id: input.value,
            uiType: UIType.CHECKBOX,
            value: input.isSelected
        })
    ;
    return formatOptInsWithSelection(availableOptIns1, selectedOptIns1).map((optin)=>swcHelpers.objectSpread({
            literalText: getLabel(optin.titleKey)
        }, formatOptIn(optin))
    );
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createOptInsUpdate: createOptInsUpdate,
  getParsedDataFromLS: getParsedDataFromLS,
  writeUserDataToLS: writeUserDataToLS,
  removeUserDataFromLS: removeUserDataFromLS,
  formatError: formatError,
  history: history,
  parseAuth0StateParam: parseAuth0StateParam,
  randomString: randomString,
  redirect: redirect,
  ungroupOptIns: ungroupOptIns,
  omitGroupedOptIns: omitGroupedOptIns,
  formatOptIns: formatOptIns
});

class EmailSentConfirmation extends React.Component {
    render() {
        const { buttonCaption , className , email , firstParagraph , secondParagraph , title  } = this.props;
        const error = formatError(this.props.error);
        const errorKey = typeof error === 'string' ? error : error.join(' ');
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames('email-sent-confirmation', 'myaccount__section', className)
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "medium"
        }, title), error && /*#__PURE__*/ React.createElement(ScrollIntoView, {
            key: errorKey
        }, /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            message: formatError(this.props.error)
        })), /*#__PURE__*/ React.createElement("p", {
            className: "email-sent-confirmation__text"
        }, this.replaceEmail(firstParagraph, email)), /*#__PURE__*/ React.createElement("p", {
            className: "email-sent-confirmation__text"
        }, this.replaceEmail(secondParagraph, email)), /*#__PURE__*/ React.createElement(Button, {
            "data-t": "re-send",
            className: "email-sent-confirmation__button",
            onClick: this.sendEmail,
            disabled: this.state.isEmailSent,
            caption: buttonCaption,
            variant: "outline"
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isEmailSent: false
        };
        this.replaceEmail = (label, email)=>{
            return label && label.replace('{{email}}', email) || '';
        };
        this.sendEmail = ()=>{
            this.props.onResend({
                email: this.props.email
            });
            this.setState({
                isEmailSent: true
            });
        };
    }
}

var AuthState;
(function(AuthState) {
    AuthState["Uninitialized"] = 'uninitialized';
    AuthState["Initialized"] = 'initialized';
    AuthState["LoggedIn"] = 'logged-in';
    AuthState["LoggedOut"] = 'logged-out';
    AuthState["ParseHashFailed"] = 'parse-hash-failed';
})(AuthState || (AuthState = {}));
function getLoggedInState(auth) {
    if (!auth || isUninitialized$1(auth) || isInitialized$1(auth)) {
        return 'loading';
    }
    if (isLoggedIn$1(auth)) {
        return AuthState.LoggedIn;
    }
    return AuthState.LoggedOut;
}
const isState = (stateName)=>(state)=>state.state === stateName
;
const isUninitialized$1 = isState(AuthState.Uninitialized);
const isInitialized$1 = isState(AuthState.Initialized);
const isLoggedInPasswordless = (state)=>state.state === AuthState.LoggedIn && state.type === 'passwordless'
;
const isLoggedIn$1 = (state)=>state.state === AuthState.LoggedIn && state.type === 'regular'
;
const isParseHashFailed = isState(AuthState.ParseHashFailed);
const isLoggedOut$1 = isState(AuthState.LoggedOut);

var state = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AuthState () { return AuthState; },
  getLoggedInState: getLoggedInState,
  isUninitialized: isUninitialized$1,
  isInitialized: isInitialized$1,
  isLoggedInPasswordless: isLoggedInPasswordless,
  isLoggedIn: isLoggedIn$1,
  isParseHashFailed: isParseHashFailed,
  isLoggedOut: isLoggedOut$1
});

const getAuth = (state)=>state.auth
;
/**
 * This will return true for all states except uninitialized
 */ const isInitialized = createSelector(getAuth, (auth)=>auth && !isUninitialized$1(auth)
);
const isUninitialized = createSelector(getAuth, (auth)=>isUninitialized$1(auth)
);
const isLoggedIn = createSelector(getAuth, (auth)=>auth && auth.state === AuthState.LoggedIn
);
const isLoggedOut = createSelector(getAuth, (auth)=>auth && auth.state === AuthState.LoggedOut
);
const getRouting = createSelector(getAuth, (auth)=>isUninitialized$1(auth) ? undefined : auth.routing
);
const getRoutes = createSelector(getRouting, (routing)=>routing ? routing.routes : undefined
);
const getBasePath = createSelector(getRouting, (routing)=>routing ? routing.basePath : undefined
);
const getCheckoutRoute = createSelector(getRouting, (routing)=>routing ? routing.checkoutRoute : undefined
);
const getFormattedRoutes = createSelector(getRoutes, getBasePath, (routes, basePath)=>{
    if (!routes || !basePath) {
        return undefined;
    }
    return Object.entries(routes).reduce((formattedRoutes, [name, route])=>swcHelpers.objectSpread({
            [name]: `/${basePath}/${route}`
        }, formattedRoutes)
    , {});
});
const getDomain = createSelector(isInitialized, getAuth, (isInitialized1, auth)=>isInitialized1 ? auth.domain : undefined
);
const getCustomDomain = createSelector(isInitialized, getAuth, (isInitialized2, auth)=>isInitialized2 ? auth.customDomain : undefined
);
const getUserId = createSelector(getAuth, (auth)=>isLoggedIn$1(auth) ? auth.userId : undefined
);
/**
 * Opt-In selectors for OpCo configured opt-ins
 */ /**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ const getOptIns = createSelector(getAuth, (auth)=>!isUninitialized$1(auth) ? auth.optIns : []
);
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ const getOptInsForSignup = createSelector(getOptIns, (optIns)=>optIns.filter((o)=>o.isInSignup
    )
);
const getUserSettings = createSelector(getAuth, (auth)=>isLoggedIn$1(auth) ? auth.userSettings : undefined
);
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-opt-ins.ts
 */ const getChangedOptIns = createSelector(getUserSettings, (userSettings)=>userSettings ? userSettings.optInsState.changedOptIns : {}
);
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-opt-ins.ts
 */ const getOptInsOnServer = createSelector(getUserSettings, (userSettings)=>{
    return userSettings ? userSettings === null || userSettings === void 0 ? void 0 : userSettings.optInsState.optInsOnServer : uninitState();
});
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-opt-ins.ts
 */ const getUpdateOptInsCall = createSelector(getUserSettings, (userSettings)=>userSettings ? userSettings.optInsState.updateOptInsCall : idleState()
);
const getUserDataState = createSelector(getUserSettings, (userSettings)=>{
    return userSettings === null || userSettings === void 0 ? void 0 : userSettings.userDataState;
});
const getUserData = createSelector(getUserDataState, (userDataState)=>{
    return userDataState === null || userDataState === void 0 ? void 0 : userDataState.userData;
});
const getCallStatus = createSelector(getUserDataState, (userDataState)=>{
    return userDataState === null || userDataState === void 0 ? void 0 : userDataState.updateCalls;
});

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAuth: getAuth,
  isInitialized: isInitialized,
  isUninitialized: isUninitialized,
  isLoggedIn: isLoggedIn,
  isLoggedOut: isLoggedOut,
  getRouting: getRouting,
  getRoutes: getRoutes,
  getBasePath: getBasePath,
  getCheckoutRoute: getCheckoutRoute,
  getFormattedRoutes: getFormattedRoutes,
  getDomain: getDomain,
  getCustomDomain: getCustomDomain,
  getUserId: getUserId,
  getOptIns: getOptIns,
  getOptInsForSignup: getOptInsForSignup,
  getUserSettings: getUserSettings,
  getChangedOptIns: getChangedOptIns,
  getOptInsOnServer: getOptInsOnServer,
  getUpdateOptInsCall: getUpdateOptInsCall,
  getUserDataState: getUserDataState,
  getUserData: getUserData,
  getCallStatus: getCallStatus
});

const toOptIns = (raw)=>{
    if (!raw) return [];
    var _id, _literalText, _value;
    return raw.reduce((optInsArray, optIn)=>[
            ...optInsArray,
            {
                id: (_id = optIn.id) !== null && _id !== void 0 ? _id : '',
                literalText: (_literalText = optIn.literalText) !== null && _literalText !== void 0 ? _literalText : '',
                value: (_value = optIn.value) !== null && _value !== void 0 ? _value : false
            }, 
        ]
    , []);
};

var OptInsFragment = gql`
  fragment OptInsFragment on OptIn {
    id
    literalText
    uiType
    value
    __typename
  }
`;

var UPDATE_OPT_INS$1 = gql`
  mutation updateOptIns($customerId: ID!, $optinUpdates: [OptInsInput!]!) {
    updateB2COptIns(customerId: $customerId, optinUpdates: $optinUpdates) {
      id
      optIns {
        ...OptInsFragment
      }
      __typename
    }
  }
  ${OptInsFragment}
`;

var GET_OPT_INS = gql`
  query getOptIns {
    me {
      id
      optIns {
        ...OptInsFragment
      }
      __typename
    }
  }
  ${OptInsFragment}
`;

const useAvailableOptIns = ()=>{
    const auth = useSelector(getAuth);
    return useMemo(()=>({
            availableOptIns: !isUninitialized$1(auth) ? auth.optIns : []
        })
    , [
        auth
    ]);
};

const useOptIns = ({ onError , onCompleted  } = {})=>{
    const auth = useSelector(getAuth);
    const [optInsFromServer, setOptInsFromServer] = React__default.useState([]);
    let authError = undefined;
    const { availableOptIns  } = useAvailableOptIns();
    if (!isLoggedIn$1(auth)) {
        authError = new ApolloError({
            errorMessage: `Can't fetch opt-ins when user isn't logged in`
        });
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'AUTH',
            error: authError
        });
    }
    const handleQueryError = React__default.useCallback((error)=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'QUERY',
            error
        });
    }, [
        onError
    ]);
    const handleMutationError = React__default.useCallback((error)=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION',
            error
        });
    }, [
        onError
    ]);
    const queryOptions = React__default.useMemo(()=>{
        return {
            skip: Boolean(authError),
            onError: handleQueryError,
            onCompleted: (data)=>{
                var ref;
                setOptInsFromServer(toOptIns((ref = data.me) === null || ref === void 0 ? void 0 : ref.optIns));
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('QUERY');
            }
        };
    }, [
        authError,
        handleQueryError,
        onCompleted
    ]);
    const query = useQuery(GET_OPT_INS, queryOptions);
    const mutationOptions = React__default.useMemo(()=>{
        return {
            skip: Boolean(authError),
            onError: handleMutationError,
            onCompleted: (data)=>{
                var ref;
                setOptInsFromServer(toOptIns((ref = data.updateB2COptIns) === null || ref === void 0 ? void 0 : ref.optIns));
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
            }
        };
    }, [
        authError,
        handleMutationError,
        onCompleted
    ]);
    const [mutationCallback, mutation] = useMutation(UPDATE_OPT_INS$1, mutationOptions);
    const updateOptIns = React__default.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(changedOptIns) {
            /**
       * If there were no changes in opt-in values, act as if the mutation
       * completed successfully, without doing the actual mutation.
       */ if (!changedOptIns.length) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
                return;
            }
            // Append with `uiType` for conversion to GQL interface
            const updatedOptIns = changedOptIns.map((optIn)=>swcHelpers.objectSpread({}, optIn, {
                    uiType: UIType.CHECKBOX
                })
            );
            yield mutationCallback({
                variables: {
                    customerId: auth.userId,
                    optinUpdates: updatedOptIns
                }
            });
        });
        return function(changedOptIns) {
            return _ref.apply(this, arguments);
        };
    }(), [
        auth.userId,
        mutationCallback,
        onCompleted
    ]);
    return React__default.useMemo(()=>({
            optInsFromServer,
            availableOptIns,
            updateOptIns,
            isFetching: query.loading,
            fetchError: authError || query.error,
            isUpdating: mutation.loading,
            updateError: mutation.error
        })
    , [
        authError,
        availableOptIns,
        mutation.error,
        mutation.loading,
        optInsFromServer,
        query.error,
        query.loading,
        updateOptIns, 
    ]);
};

const CREATE_ACCOUNT = gql`
  mutation CreateB2CCustomerAccount($input: CreateB2CCustomerAccountInput!) {
    createB2CCustomerAccount(input: $input) {
      customerId
    }
  }
`;

const SET_PASSWORD$1 = gql`
  mutation ActivateCustomerAccount($input: ActivateAccountInput!) {
    activateCustomerAccount(input: $input) {
      customerId
    }
  }
`;

// graphql endpoint wants iso format (yyyy-mm-dd)
const formatDateOfBirth = (inDate)=>{
    const [year, month, day] = inDate.split('-');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
const isFullPersonalDetails = (input)=>!!(input.firstName && input.lastName && input.phone && input.dateOfBirth)
;
const formatPersonalDetails = (input)=>({
        firstName: input.firstName,
        lastName: input.lastName,
        phone: input.phone,
        salutation: input.salutation,
        dateOfBirth: input.dateOfBirth && formatDateOfBirth(input.dateOfBirth)
    })
;
const useCreateAccount = ()=>{
    var ref;
    const [createAccount, { data , loading , error  }] = useMutation(CREATE_ACCOUNT);
    const { getLabel  } = useIntl();
    const locale = LocaleUtils.getLocaleFromCookie() || '';
    const callback = ({ email , availableOptIns , selectedOptIns , personalDetails , loginRedirectUrl  })=>createAccount({
            variables: {
                input: swcHelpers.objectSpread({
                    email
                }, personalDetails && isFullPersonalDetails(personalDetails) ? {
                    personalDetails: formatPersonalDetails(personalDetails)
                } : {}, {
                    optIns: formatOptIns(availableOptIns, selectedOptIns, getLabel),
                    reason: AccountReason.SIGN_UP,
                    accountMetaData: {
                        accountOrigination: AccountOrigination.ONLINE,
                        accountVerificationMethod: AccountVerificationMethod.NONE
                    },
                    loginRedirectUrl
                }, locale ? {
                    locale
                } : null)
            }
        })
    ;
    return [
        callback,
        {
            customerId: (data === null || data === void 0 ? void 0 : (ref = data.createB2CCustomerAccount) === null || ref === void 0 ? void 0 : ref.customerId) || '',
            loading,
            error
        }, 
    ];
};

const SignUpForm = ({ onSubmit , className , signUpForm , renderOptIns , isButtonLoading , buttonLabel , children ,  })=>{
    const handleSubmit = (formState)=>{
        const formValues = Util.getValuesFromState(formState.formState);
        onSubmit(formValues.email, pickBy(formValues, identity));
    };
    return /*#__PURE__*/ React__default.createElement(Form, {
        name: "signup-form",
        onSubmit: handleSubmit,
        className: classnames('signup-form', className)
    }, /*#__PURE__*/ React__default.createElement("fieldset", {
        className: "signup-form__fieldset"
    }, signUpForm), renderOptIns, /*#__PURE__*/ React__default.createElement(Button, {
        "data-t": "submit",
        type: "submit",
        isLoading: isButtonLoading,
        caption: buttonLabel,
        className: "signup-form__button"
    }), children);
};

const SignUp = ({ labels , loginUrl , onFormSubmit , optIns , signUpFields , termsRichText  })=>/*#__PURE__*/ React.createElement("div", {
        className: "signup"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "signup__signup-section"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium"
    }, labels.signup.title), /*#__PURE__*/ React.createElement(SignUpForm, {
        "data-t": "signup-form",
        onSubmit: onFormSubmit,
        renderOptIns: optIns,
        signUpForm: signUpFields,
        buttonLabel: labels.actions.createAccount
    }, termsRichText && /*#__PURE__*/ React.createElement("div", {
        className: "signup__terms"
    }, /*#__PURE__*/ React.createElement(RichTextArea, {
        content: termsRichText
    }))), labels.dataConsent && /*#__PURE__*/ React.createElement(Text, {
        className: "signup__data-processing-disclaimer",
        variant: "caption"
    }, labels.dataConsent)), /*#__PURE__*/ React.createElement("section", {
        className: "signup__login-section"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "small"
    }, labels.hasAccount.title), /*#__PURE__*/ React.createElement("p", {
        className: "signup__login-text"
    }, labels.hasAccount.text), /*#__PURE__*/ React.createElement(Button, {
        className: "signup__login-button",
        caption: labels.actions.login,
        variant: "outline",
        "data-t": "to-login",
        href: loginUrl
    })))
;

const SignUpContainer = ({ termsRichText , loginUrl , signUpFields  })=>{
    var ref;
    const { getLabel , hasLabel , getFormattedLabel  } = useIntl();
    const auth = useSelector(getAuth);
    const { availableOptIns  } = useAvailableOptIns();
    const availableOptInsForSignUp = availableOptIns.filter((o)=>o.isInSignup
    );
    const [createAccount, { error , loading , customerId  }] = useCreateAccount();
    const { protocol , host  } = window.location;
    const loginRedirectUrl = `${protocol}//${host}/${(ref = auth.routing) === null || ref === void 0 ? void 0 : ref.basePath}/callback`;
    const labels = {
        error: getLabel('account.createAccount.signup.errors.general'),
        dataConsent: hasLabel('account.consent.dataProcessing') ? getFormattedLabel('account.consent.dataProcessing', {
            parseLink: true
        }) : undefined,
        hasAccount: {
            title: getLabel('account.hasAccount.title'),
            text: getLabel('account.hasAccount.text')
        },
        signup: {
            title: getLabel('account.signup.title')
        },
        actions: {
            login: getLabel('account.action.login'),
            createAccount: getLabel('account.action.createAccount')
        }
    };
    const [userData, setUserData] = React.useState(()=>({
            email: ''
        })
    );
    const [hasSignedUp, setHasSignedUp] = React.useState(false);
    const [selectedOptIns, setSelectedOptIns] = React.useState([]);
    const optIns = React.useMemo(()=>{
        if (!availableOptInsForSignUp || availableOptInsForSignUp.length === 0) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(CheckboxList, {
            idPrefix: "opt-in__",
            items: availableOptInsForSignUp,
            onChange: setSelectedOptIns,
            selectedItems: selectedOptIns,
            getItemIdentifier: (optIn)=>optIn.titleKey
            ,
            renderItem: (item)=>/*#__PURE__*/ React.createElement("span", null, getFormattedLabel(item.titleKey, {
                    parseHTML: true
                }))
        });
    }, [
        availableOptInsForSignUp,
        getFormattedLabel,
        selectedOptIns
    ]);
    const signUp = React.useCallback(()=>{
        createAccount({
            email: userData.email,
            availableOptIns: availableOptInsForSignUp,
            selectedOptIns,
            personalDetails: userData.personalDetails,
            loginRedirectUrl
        });
    }, [
        selectedOptIns,
        userData.email,
        userData.personalDetails
    ]);
    const handleSubmit = (email, personalDetails)=>{
        setUserData({
            email,
            personalDetails
        });
        setHasSignedUp(true);
    };
    React.useEffect(()=>{
        if (userData.email) {
            signUp();
        }
    }, [
        signUp,
        userData
    ]);
    if (isUninitialized$1(auth)) {
        throw new Error(`Should not render SignUp page when auth is not initialized`);
    }
    if (hasSignedUp) {
        const error = statusFailed(auth.signupCall) ? new Error(getLabel('account.createAccount.signup.errors.general')) : undefined;
        return /*#__PURE__*/ React.createElement(EmailSentConfirmation, {
            error: error,
            email: userData.email,
            onResend: signUp,
            title: getLabel('account.signupConfirmation.title'),
            firstParagraph: getLabel('account.signupConfirmation.firstParagraph'),
            secondParagraph: getLabel('account.signupConfirmation.secondParagraph'),
            buttonCaption: getLabel('account.action.resendEmail')
        });
    }
    return /*#__PURE__*/ React.createElement(SignUp, {
        labels: labels,
        loginUrl: loginUrl,
        optIns: optIns,
        onFormSubmit: handleSubmit,
        signUpFields: signUpFields,
        termsRichText: termsRichText
    });
};

const SIGNUP = 'my-account/create/signup';
const SIGNUP_SUCCESS = 'my-account/create/sign-success';
const SIGNUP_FAILED = 'my-account/create/signup-failed';
const SET_PASSWORD = 'my-account/create/set-password';
const SET_PASSWORD_SUCCESS = 'my-account/create/set-password-success';
const SET_PASSWORD_FAILED = 'my-account/create/set-password-failed';
const signup = (payload)=>({
        type: SIGNUP,
        payload
    })
;
const signUpSuccess = (payload)=>({
        type: SIGNUP_SUCCESS,
        payload
    })
;
const signUpFailed = (error)=>({
        type: SIGNUP_FAILED,
        error
    })
;
const setPassword = (payload)=>({
        type: SET_PASSWORD,
        payload
    })
;
const setPasswordSuccess = (payload)=>({
        type: SET_PASSWORD_SUCCESS,
        payload
    })
;
const setPasswordFailed = (error)=>({
        type: SET_PASSWORD_FAILED,
        error
    })
;

var actions$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SIGNUP: SIGNUP,
  SIGNUP_SUCCESS: SIGNUP_SUCCESS,
  SIGNUP_FAILED: SIGNUP_FAILED,
  SET_PASSWORD: SET_PASSWORD,
  SET_PASSWORD_SUCCESS: SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILED: SET_PASSWORD_FAILED,
  signup: signup,
  signUpSuccess: signUpSuccess,
  signUpFailed: signUpFailed,
  setPassword: setPassword,
  setPasswordSuccess: setPasswordSuccess,
  setPasswordFailed: setPasswordFailed
});

const LOGIN = 'account/login';
const LOGIN_FAILED = 'account/login_failed';
const PARSE_HASH = 'account/login/parse-hash';
const PARSE_HASH_FAILED = 'account/login/parse-hash-failed';
const PARSE_HASH_SUCCEEDED = 'account/login_success';
const RECOVER_SESSION = 'account/login/recover-session';
const RECOVER_SESSION_FAILED = 'account/login/recover-session-failed';
const ASSERT_SESSION = 'account/login/assert-session';
const ASSERT_SESSION_FAILED = 'account/login/assert-session-failed';
const loginWithPassword = (payload)=>({
        type: LOGIN,
        payload
    })
;
const parseHash$2 = ()=>({
        type: PARSE_HASH
    })
;
const parseHashFailed = (payload)=>({
        type: PARSE_HASH_FAILED,
        payload
    })
;
const parseHashSucceeded = (payload)=>({
        type: PARSE_HASH_SUCCEEDED,
        payload
    })
;
const loginFailed = (error)=>({
        type: LOGIN_FAILED,
        error
    })
;
const recoverSession$1 = ()=>({
        type: RECOVER_SESSION
    })
;
const recoverSessionFailed = (error)=>({
        type: RECOVER_SESSION_FAILED,
        error
    })
;
const assertSession$1 = ()=>({
        type: ASSERT_SESSION
    })
;
const assertSessionFailed = (error)=>({
        type: ASSERT_SESSION_FAILED,
        error
    })
;

var actions$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LOGIN: LOGIN,
  LOGIN_FAILED: LOGIN_FAILED,
  PARSE_HASH: PARSE_HASH,
  PARSE_HASH_FAILED: PARSE_HASH_FAILED,
  PARSE_HASH_SUCCEEDED: PARSE_HASH_SUCCEEDED,
  RECOVER_SESSION: RECOVER_SESSION,
  RECOVER_SESSION_FAILED: RECOVER_SESSION_FAILED,
  ASSERT_SESSION: ASSERT_SESSION,
  ASSERT_SESSION_FAILED: ASSERT_SESSION_FAILED,
  loginWithPassword: loginWithPassword,
  parseHash: parseHash$2,
  parseHashFailed: parseHashFailed,
  parseHashSucceeded: parseHashSucceeded,
  loginFailed: loginFailed,
  recoverSession: recoverSession$1,
  recoverSessionFailed: recoverSessionFailed,
  assertSession: assertSession$1,
  assertSessionFailed: assertSessionFailed
});

const LOG_OUT = 'account/log_out';
const LOGGED_OUT = 'account/logged_out';
const logOut$1 = ()=>({
        type: LOG_OUT
    })
;
const loggedOut = ()=>({
        type: LOGGED_OUT
    })
;

var actions$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LOG_OUT: LOG_OUT,
  LOGGED_OUT: LOGGED_OUT,
  logOut: logOut$1,
  loggedOut: loggedOut
});

/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-opt-ins.ts
 */ /** @deprecated use the new GQL hook use-opt-ins.ts */ const FETCH_OPT_INS = 'opt-ins/fetch-opt-ins';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const FETCH_OPT_INS_SUCCESS = 'opt-ins/fetch-opt-ins-success';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const FETCH_OPT_INS_FAILED = 'opt-ins/fetch-opt-ins-failed';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const TOGGLE_OPT_INS = 'opt-ins/toggle-opt-ins';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const UPDATE_OPT_INS = 'opt-ins/update-opt-ins';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const UPDATE_OPT_INS_SUCCESS = 'opt-ins/update-opt-ins-success';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const UPDATE_OPT_INS_FAILED = 'opt-ins/update-opt-ins-failed';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const toggleOptIns = (payload)=>({
        type: TOGGLE_OPT_INS,
        payload
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const fetchOptIns$1 = ()=>({
        type: FETCH_OPT_INS
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const fetchOptInsSuccess = (payload)=>({
        type: FETCH_OPT_INS_SUCCESS,
        payload
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const fetchOptInsFailed = (error)=>({
        type: FETCH_OPT_INS_FAILED,
        error
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const updateOptIns$1 = (payload)=>({
        type: UPDATE_OPT_INS,
        payload
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const updateOptInsSuccess = ()=>({
        type: UPDATE_OPT_INS_SUCCESS
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const updateOptInsFailed = (error)=>({
        type: UPDATE_OPT_INS_FAILED,
        error
    })
;

var actions$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_OPT_INS: FETCH_OPT_INS,
  FETCH_OPT_INS_SUCCESS: FETCH_OPT_INS_SUCCESS,
  FETCH_OPT_INS_FAILED: FETCH_OPT_INS_FAILED,
  TOGGLE_OPT_INS: TOGGLE_OPT_INS,
  UPDATE_OPT_INS: UPDATE_OPT_INS,
  UPDATE_OPT_INS_SUCCESS: UPDATE_OPT_INS_SUCCESS,
  UPDATE_OPT_INS_FAILED: UPDATE_OPT_INS_FAILED,
  toggleOptIns: toggleOptIns,
  fetchOptIns: fetchOptIns$1,
  fetchOptInsSuccess: fetchOptInsSuccess,
  fetchOptInsFailed: fetchOptInsFailed,
  updateOptIns: updateOptIns$1,
  updateOptInsSuccess: updateOptInsSuccess,
  updateOptInsFailed: updateOptInsFailed
});

const RESET_PASSWORD = 'account/reset-password/reset-password';
const RESET_PASSWORD_SUCCESS = 'account/reset-password/reset-password-success';
const RESET_PASSWORD_FAILED = 'account/reset-password/reset-password-failed';
const UPDATE_PASSWORD = 'account/reset-password/update-password';
const UPDATE_PASSWORD_FAILED = 'account/reset-password/update-password-failed';
const UPDATE_PASSWORD_SUCCESS = 'account/reset-password/update-password-success';
const CHANGE_PASSWORD = 'account/reset-password/change-password';
const CHANGE_PASSWORD_FAILED = 'account/reset-password/change-password-failed';
const CHANGE_PASSWORD_SUCCESS = 'account/reset-password/change-password-success';
const resetPassword = (payload)=>({
        type: RESET_PASSWORD,
        payload
    })
;
const resetPasswordSuccess = (payload)=>({
        type: RESET_PASSWORD_SUCCESS,
        payload
    })
;
const resetPasswordFailed = (error)=>({
        type: RESET_PASSWORD_FAILED,
        error
    })
;
const updatePassword = (payload)=>({
        type: UPDATE_PASSWORD,
        payload
    })
;
const updatePasswordFailed = (error)=>({
        type: UPDATE_PASSWORD_FAILED,
        error
    })
;
const updatePasswordSuccess = (payload)=>({
        type: UPDATE_PASSWORD_SUCCESS,
        payload
    })
;
const changePassword = (payload)=>({
        type: CHANGE_PASSWORD,
        payload
    })
;
const changePasswordFailed = (error)=>({
        type: CHANGE_PASSWORD_FAILED,
        error
    })
;
const changePasswordSuccess = (payload)=>({
        type: CHANGE_PASSWORD_SUCCESS,
        payload
    })
;

var actions$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RESET_PASSWORD: RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS: RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILED: RESET_PASSWORD_FAILED,
  UPDATE_PASSWORD: UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAILED: UPDATE_PASSWORD_FAILED,
  UPDATE_PASSWORD_SUCCESS: UPDATE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD: CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILED: CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS: CHANGE_PASSWORD_SUCCESS,
  resetPassword: resetPassword,
  resetPasswordSuccess: resetPasswordSuccess,
  resetPasswordFailed: resetPasswordFailed,
  updatePassword: updatePassword,
  updatePasswordFailed: updatePasswordFailed,
  updatePasswordSuccess: updatePasswordSuccess,
  changePassword: changePassword,
  changePasswordFailed: changePasswordFailed,
  changePasswordSuccess: changePasswordSuccess
});

const FETCH_USER_DATA = 'auth/fetch-user-data';
const FETCH_USER_DATA_FAILED = 'auth/fetch-user-data-failed';
const FETCH_USER_DATA_SUCCESS = 'auth/fetch-user-data-success';
const UPDATE_USER_DATA = 'auth/update-user-data';
const UPDATE_USER_DATA_FAILED = 'auth/update-user-data-failed';
const UPDATE_USER_DATA_SUCCESS = 'auth/update-user-data-success';
const fetchUserData$1 = ()=>({
        type: FETCH_USER_DATA
    })
;
const fetchUserDataFailed = (error)=>({
        type: FETCH_USER_DATA_FAILED,
        error
    })
;
const fetchUserDataSuccess = (payload)=>({
        type: FETCH_USER_DATA_SUCCESS,
        payload
    })
;
const updateUserData$1 = (payload)=>({
        type: UPDATE_USER_DATA,
        payload
    })
;
const updateUserDataFailed = (payload)=>({
        type: UPDATE_USER_DATA_FAILED,
        payload
    })
;
const updateUserDataSuccess = (payload)=>({
        type: UPDATE_USER_DATA_SUCCESS,
        payload
    })
;

var actions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_USER_DATA: FETCH_USER_DATA,
  FETCH_USER_DATA_FAILED: FETCH_USER_DATA_FAILED,
  FETCH_USER_DATA_SUCCESS: FETCH_USER_DATA_SUCCESS,
  UPDATE_USER_DATA: UPDATE_USER_DATA,
  UPDATE_USER_DATA_FAILED: UPDATE_USER_DATA_FAILED,
  UPDATE_USER_DATA_SUCCESS: UPDATE_USER_DATA_SUCCESS,
  fetchUserData: fetchUserData$1,
  fetchUserDataFailed: fetchUserDataFailed,
  fetchUserDataSuccess: fetchUserDataSuccess,
  updateUserData: updateUserData$1,
  updateUserDataFailed: updateUserDataFailed,
  updateUserDataSuccess: updateUserDataSuccess
});

const INIT = 'auth/init';
const GOTO = 'auth/goto';
const init$1 = (payload)=>({
        type: INIT,
        payload
    })
;
const goto = (payload)=>({
        type: GOTO,
        payload
    })
;

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CreateAccountActions: actions$6,
  OptInsActions: actions$3,
  UserDataActions: actions$1,
  LoginActions: actions$5,
  LogoutActions: actions$4,
  ResetPasswordActions: actions$2,
  INIT: INIT,
  GOTO: GOTO,
  init: init$1,
  goto: goto
});

var RouteKey;
(function(RouteKey) {
    RouteKey["AddressBook"] = 'addressBook';
    RouteKey["Appointments"] = 'appointments';
    RouteKey["ChangePassword"] = 'changePassword';
    RouteKey["CreateAccount"] = 'createAccount';
    RouteKey["LinkExpired"] = 'linkExpired';
    RouteKey["Login"] = 'login';
    RouteKey["Logout"] = 'logout';
    RouteKey["Orders"] = 'orders';
    RouteKey["Prescriptions"] = 'prescriptions';
    RouteKey["Profile"] = 'profile';
    RouteKey["ResetPassword"] = 'resetPassword';
    RouteKey["SetPassword"] = 'setPassword';
    RouteKey["Settings"] = 'settings';
    RouteKey["Signup"] = 'signup';
    RouteKey["Subscriptions"] = 'subscriptions';
    RouteKey["SubscriptionsV2"] = 'subscriptionsv2';
    RouteKey["UnlinkAppointment"] = 'unlinkAppointment';
    RouteKey["UnlinkOrder"] = 'unlinkOrder';
    RouteKey["Verify"] = 'verify';
})(RouteKey || (RouteKey = {}));

const mapConsents = (selectedConsents)=>selectedConsents.map((consent)=>({
            consentName: consent.value,
            literalText: consent.title,
            uiType: UIType.CHECKBOX,
            value: true
        })
    )
;
var useSetPassword = ()=>{
    var ref;
    const [setPassword, { data , loading , error  }] = useMutation(SET_PASSWORD$1);
    const callback = (_param)=>{
        var { consents  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
            "consents"
        ]);
        return setPassword({
            variables: {
                input: swcHelpers.objectSpread({
                    consents: mapConsents(consents)
                }, rest)
            }
        });
    };
    return [
        callback,
        {
            customerId: data === null || data === void 0 ? void 0 : (ref = data.activateCustomerAccount) === null || ref === void 0 ? void 0 : ref.customerId,
            loading,
            error
        }, 
    ];
};

const PasswordForm = ({ buttonCaption , 'data-t': dataT , className , passwordLabel , children , onSubmit ,  })=>{
    const { getLabel  } = useIntl();
    const [state, setState] = React.useState({
        password: {
            value: '',
            isValid: undefined
        }
    });
    const [hasError, setHasError] = React.useState(false);
    const handleSubmit = React.useCallback((event)=>{
        event.preventDefault();
        if (state.password.isValid) {
            setHasError(false);
            onSubmit(state.password.value);
        } else {
            setHasError(true);
        }
    }, [
        onSubmit,
        state
    ]);
    const setPassword = (password)=>{
        const { value , isValid  } = password;
        setState({
            password: {
                value,
                isValid
            }
        });
    };
    return /*#__PURE__*/ React.createElement("form", {
        className: classnames('password-form', className),
        "data-t": dataT,
        noValidate: true,
        onSubmit: handleSubmit
    }, hasError && /*#__PURE__*/ React.createElement(ScrollIntoView, null, /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        message: getLabel('account.passwordStrength.notStrongEnough')
    })), /*#__PURE__*/ React.createElement(PasswordWithStrengthIndicator, {
        label: passwordLabel,
        indicatorPosition: MediaQuery.useIsDesktop() ? 'right' : 'bottom',
        value: state.password.value,
        onChange: setPassword
    }), children, /*#__PURE__*/ React.createElement(Button, {
        caption: buttonCaption,
        "data-t": "submit",
        type: "submit",
        className: "password-form__button"
    }));
};

const SetPassword$2 = ({ labels , consentItems , onSubmit , hasErrors , passwordlessErrorMessage  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: "create-account myaccount__section"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "medium",
        component: "h1",
        className: "create-account__title"
    }, labels.title), /*#__PURE__*/ React__default.createElement("p", {
        className: "create-account__text"
    }, labels.text), Boolean(passwordlessErrorMessage) && /*#__PURE__*/ React__default.createElement(ScrollIntoView, {
        key: "passwordless-error"
    }, /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        message: passwordlessErrorMessage
    })), hasErrors && /*#__PURE__*/ React__default.createElement(ScrollIntoView, {
        key: "default-error"
    }, /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        message: labels.error
    })), /*#__PURE__*/ React__default.createElement(PasswordForm, {
        "data-t": "create-account-form",
        passwordLabel: labels.form.password,
        buttonCaption: labels.form.submit,
        onSubmit: onSubmit
    }, consentItems))
;

const SetPasswordContainer = ({ consentItems  })=>{
    const { getLabel  } = useIntl();
    const auth = useSelector(getAuth);
    const dispatch = useDispatch();
    const [password1, setPassword] = useState('');
    const [alreadyLoggingIn, setAlreadyLoggingIn] = useState(false);
    const [setPasswordCall, { customerId , error  }] = useSetPassword();
    const labels = {
        title: getLabel('account.createAccount.title'),
        text: getLabel('account.passwordStrength.notStrongEnough'),
        error: getLabel('account.createAccount.error.consentRequired'),
        form: {
            password: getLabel('fields.input.password.label'),
            submit: getLabel('account.action.createAccount')
        }
    };
    const [selectedConsents, setSelectedConsents] = React__default.useState([]);
    const [hasErrors, setHasErrors] = React__default.useState(false);
    const consents = React__default.useMemo(()=>{
        if (!consentItems || consentItems.length === 0) {
            return null;
        }
        return /*#__PURE__*/ React__default.createElement(CheckboxList, {
            idPrefix: "consent_",
            items: consentItems,
            renderItem: (item)=>/*#__PURE__*/ React__default.createElement("span", null, parseHtml(item.title))
            ,
            getItemIdentifier: (consent)=>consent.value
            ,
            selectedItems: selectedConsents,
            onChange: setSelectedConsents
        });
    }, [
        consentItems,
        selectedConsents
    ]);
    const handleSubmit = (password)=>{
        // Check if all consents were checked if there are any
        if (!consentItems.length || consentItems.every(({ value  })=>selectedConsents.map((c)=>c.value
            ).includes(value)
        )) {
            setPassword(password);
            setPasswordCall({
                password,
                customerId: auth.userId,
                consents: selectedConsents,
                email: auth.email
            });
        } else {
            setHasErrors(true);
        }
    };
    const passwordlessErrorMessage = isLoggedInPasswordless(auth) && statusFailed(auth.activateCall) ? getLabel('account.createAccount.setPassword.errors.general') : undefined;
    React__default.useEffect(()=>{
        if (isLoggedInPasswordless(auth) && customerId && !alreadyLoggingIn) {
            // set password was successful
            setAlreadyLoggingIn(true);
            dispatch(loginWithPassword({
                email: auth.email,
                password: password1
            }));
        } else if (isLoggedIn$1(auth)) {
            dispatch(goto({
                route: RouteKey.Profile
            }));
        } else if (isLoggedOut$1(auth)) {
            dispatch(goto({
                route: RouteKey.Login
            }));
        }
    }, [
        auth,
        dispatch,
        customerId
    ]);
    return /*#__PURE__*/ React__default.createElement(SetPassword$2, {
        labels: labels,
        consentItems: consents,
        onSubmit: handleSubmit,
        hasErrors: hasErrors || !!error,
        passwordlessErrorMessage: passwordlessErrorMessage
    });
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SignUp: SignUpContainer,
  SetPassword: SetPasswordContainer
});

const elementName$1 = 'set-password';
class SetPassword extends React.Component {
    render() {
        const { intl , auth  } = this.props;
        if (!isLoggedInPasswordless(auth)) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(elementName$1, 'myaccount__section')
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "medium",
            className: classnames(`${elementName$1}__title`)
        }, intl.getLabel('account.resetPassword.confirmation.title')), /*#__PURE__*/ React.createElement("p", {
            className: `${elementName$1}__text`
        }, intl.getLabel('account.resetPassword.setPassword.text')), statusFailed(auth.setPasswordCall) && /*#__PURE__*/ React.createElement(ScrollIntoView, null, /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            message: intl.getLabel('account.resetPassword.updatePassword.errors.general')
        })), /*#__PURE__*/ React.createElement(PasswordForm, {
            "data-t": "set-password-form",
            passwordLabel: intl.getLabel('fields.input.password.label'),
            buttonCaption: intl.getLabel('account.action.setPassword'),
            onSubmit: this.onSubmit
        }));
    }
    constructor(...args){
        super(...args);
        this.onSubmit = (password)=>{
            this.props.updatePassword({
                password
            });
        };
    }
}
const mapDispatchToProps$3 = {
    updatePassword: updatePassword
};
const mapStateToProps$3 = (state)=>({
        auth: getAuth(state)
    })
;
var SetPassword$1 = connect(mapStateToProps$3, mapDispatchToProps$3)(withIntl(SetPassword));

class EmailForm extends React.Component {
    render() {
        const { email  } = this.state;
        const { dataT , buttonLabel , isButtonDisabled , isButtonLoading , className , children , emailLabel , emailErrorLabel , renderOptIns ,  } = this.props;
        return /*#__PURE__*/ React.createElement("form", {
            onSubmit: this.handleSubmit,
            className: classnames('email-form', className),
            noValidate: true,
            "data-t": dataT
        }, /*#__PURE__*/ React.createElement(Email, {
            "data-t": "email",
            required: true,
            label: emailLabel,
            errorMessage: emailErrorLabel,
            onChange: this.setEmail,
            hideAsteriskSign: true
        }), renderOptIns, /*#__PURE__*/ React.createElement(Button, {
            "data-t": "submit",
            type: "submit",
            disabled: isButtonDisabled || !email.isValid,
            isLoading: isButtonLoading,
            caption: buttonLabel,
            className: "email-form__button"
        }), children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            email: {
                value: '',
                isValid: undefined
            }
        };
        this.setEmail = (state)=>{
            this.setState(()=>({
                    email: {
                        value: state.value,
                        isValid: state.isValid
                    }
                })
            );
        };
        this.handleSubmit = (event)=>{
            event.preventDefault();
            const { email  } = this.state;
            const { onSubmit  } = this.props;
            if (email.isValid === true) {
                onSubmit(email.value);
            }
        };
    }
}

const elementName = 'submit-email-address';
class SubmitEmailAddress extends React.Component {
    render() {
        const { intl , auth  } = this.props;
        const { email , isEmailSubmitted  } = this.state;
        if (isUninitialized$1(auth)) {
            return null;
        }
        const error = statusFailed(auth.resetPasswordCall) ? new Error(intl.getLabel('account.resetPassword.updatePassword.errors.general')) : undefined;
        // If email is submitted and call is finished we can show confirmation screen
        if (isEmailSubmitted) {
            return /*#__PURE__*/ React.createElement(EmailSentConfirmation, {
                onResend: this.onHandleResend,
                email: email,
                title: intl.getLabel('account.resetPassword.confirmation.title'),
                firstParagraph: intl.getLabel('account.resetPassword.confirmation.firstParagraph'),
                secondParagraph: intl.getLabel('account.resetPassword.confirmation.secondParagraph'),
                buttonCaption: intl.getLabel('account.action.resendEmail'),
                error: error
            });
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(elementName, 'myaccount__section')
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "medium",
            component: "h1",
            className: `${elementName}__title`
        }, intl.getLabel('account.resetPassword.submitEmailAddress.title')), /*#__PURE__*/ React.createElement("p", {
            className: `${elementName}__text`
        }, intl.getLabel('account.resetPassword.submitEmailAddress.text')), /*#__PURE__*/ React.createElement(EmailForm, {
            buttonLabel: intl.getLabel('account.action.resetPassword'),
            "data-t": "reset-password-form",
            emailErrorLabel: intl.getLabel('account.error.emailInvalid'),
            emailLabel: intl.getLabel('fields.input.email.label'),
            onSubmit: this.onSubmit
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            email: '',
            isEmailSubmitted: false
        };
        this.onHandleResend = ()=>{
            this.props.resetPassword({
                email: this.state.email
            });
        };
        this.onSubmit = (email)=>{
            this.setState({
                email,
                isEmailSubmitted: true
            }, ()=>{
                this.props.resetPassword({
                    email
                });
            });
        };
    }
}
const mapStateToProps$2 = (state)=>({
        auth: getAuth(state)
    })
;
const mapDispatchToProps$2 = {
    resetPassword: resetPassword
};
var SubmitEmailAddress$1 = connect(mapStateToProps$2, mapDispatchToProps$2)(withIntl(SubmitEmailAddress));

const VALIDATE_ACCOUNT = gql`
  mutation ValidateCustomerAccount($input: ValidateAccountInput!) {
    validateCustomerAccount(input: $input) {
      ... on AccountValidatedSuccessfully {
        customerId
      }
      ... on AccountValidationMaxRetriesError {
        retries
      }
    }
  }
`;

const useValidateAccount = ()=>{
    const [isWrongDOB, setIsWrongDOB] = useState(false);
    const onError = useCallback(({ graphQLErrors , networkError  })=>{
        setIsWrongDOB(true);
        return null;
    }, [
        setIsWrongDOB
    ]);
    const [validateAccount, { data , loading , error  }] = useMutation(VALIDATE_ACCOUNT, {
        onError
    });
    const callback = (input)=>{
        setIsWrongDOB(false);
        validateAccount({
            variables: {
                input
            }
        }).catch((e)=>setIsWrongDOB(true)
        );
    };
    if ((data === null || data === void 0 ? void 0 : data.validateCustomerAccount.__typename) === 'AccountValidatedSuccessfully') {
        return [
            callback,
            {
                customerId: data === null || data === void 0 ? void 0 : data.validateCustomerAccount.customerId,
                loading,
                error,
                isWrongDOB
            }, 
        ];
    } else if ((data === null || data === void 0 ? void 0 : data.validateCustomerAccount.__typename) === 'AccountValidationMaxRetriesError') {
        return [
            callback,
            {
                retries: data === null || data === void 0 ? void 0 : data.validateCustomerAccount.retries,
                loading,
                error,
                isWrongDOB
            }, 
        ];
    }
    return [
        callback,
        {
            loading,
            error,
            isWrongDOB
        }
    ];
};

const formatDate = (date)=>{
    const [year, month, day] = date.split('-');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
var Verify = (()=>{
    const elementName = 'verify';
    const { getLabel  } = useIntl();
    const auth = useSelector(getAuth);
    const dispatch = useDispatch();
    const [formState1, setFormState] = useState(Util.fieldsToFormState({
        dob: ''
    }));
    const [validateAccount, { error , loading , customerId , retries , isWrongDOB  }, ] = useValidateAccount();
    const handleSubmit = useCallback((formState)=>{
        const { dob  } = Util.getValuesFromState(formState.formState);
        if (dob) {
            try {
                validateAccount({
                    customerId: auth.userId,
                    validationValue: formatDate(dob)
                });
            } catch (e) {
                console.warn(e);
                console.warn(error);
            }
        }
    }, [
        validateAccount,
        formState1.formState
    ]);
    const handleChange = (newState)=>setFormState(newState.formState)
    ;
    useEffect(()=>{
        if (customerId) dispatch(goto({
            route: RouteKey.CreateAccount
        }));
    }, [
        customerId,
        dispatch
    ]);
    if (isUninitialized$1(auth)) {
        throw new Error('Should not render SignUp page when auth is not initialized');
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames(elementName, 'myaccount__section')
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "medium",
        className: classnames(`${elementName}__title`)
    }, getLabel('account.resetPassword.validation.title')), /*#__PURE__*/ React__default.createElement(Text, {
        className: `${elementName}__text`
    }, getLabel('account.resetPassword.validation.text')), isWrongDOB && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        icon: "alert-circle",
        message: getLabel('account.resetPassword.validation.error.wrongDateOfBirth')
    }), retries && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        icon: "alert-circle",
        message: getLabel('account.resetPassword.validation.error.tooManyAttempts')
    }), /*#__PURE__*/ React__default.createElement(Form, {
        name: "verify-form",
        "data-t": "verify-form",
        className: classnames('password-form'),
        initialFormState: formState1,
        onChange: handleChange,
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React__default.createElement(DateOfBirthSelect, {
        name: "dob",
        label: getLabel('account.resetPassword.validation.dateOfBirth'),
        dayPlaceholder: getLabel('checkout.contact.dateofbirth.day.placeholder'),
        monthPlaceholder: getLabel('checkout.contact.dateofbirth.month.placeholder'),
        yearPlaceholder: getLabel('checkout.contact.dateofbirth.year.placeholder'),
        errorMessage: getLabel('account.resetPassword.validation.error.noDateOfBirth'),
        validations: [
            Util.validations.isDateOfBirth,
            Util.validations.isRequired
        ],
        required: true
    }), /*#__PURE__*/ React__default.createElement(Button, {
        caption: getLabel('account.action.confirm'),
        "data-t": "submit",
        type: "submit",
        className: "password-form__button",
        disabled: retries !== undefined,
        isLoading: loading
    })));
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SetPassword: SetPassword$1,
  SubmitEmailAddress: SubmitEmailAddress$1,
  Verify: Verify
});

/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ const initialState$2 = {
    optInsOnServer: uninitState(),
    changedOptIns: {},
    updateOptInsCall: idleState()
};
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ function optInsReducer(state = initialState$2, action) {
    switch(action.type){
        case FETCH_OPT_INS:
            return swcHelpers.objectSpread({}, state, {
                optInsOnServer: loadingState()
            });
        case FETCH_OPT_INS_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                optInsOnServer: successState(action.payload)
            });
        case FETCH_OPT_INS_FAILED:
            return swcHelpers.objectSpread({}, state, {
                optInsOnServer: failedState(action.error)
            });
        case TOGGLE_OPT_INS:
            return swcHelpers.objectSpread({}, state, {
                changedOptIns: swcHelpers.objectSpread({}, state.changedOptIns, action.payload)
            });
        case UPDATE_OPT_INS:
            return swcHelpers.objectSpread({}, state, {
                updateOptInsCall: loadingState()
            });
        case UPDATE_OPT_INS_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                updateOptInsCall: idleState()
            });
        case UPDATE_OPT_INS_FAILED:
            return swcHelpers.objectSpread({}, state, {
                updateOptInsCall: failedState(action.error)
            });
    }
    return state;
}

const initialState$1 = {
    userData: uninitState(),
    updateCalls: {
        personalDetails: idleState(),
        billingAddress: idleState(),
        preferredStore: idleState()
    }
};
function userDataReducer(state = initialState$1, action) {
    switch(action.type){
        case FETCH_USER_DATA:
            return swcHelpers.objectSpread({}, state, {
                userData: loadingState()
            });
        case FETCH_USER_DATA_FAILED:
            return swcHelpers.objectSpread({}, state, {
                userData: failedState(action.error)
            });
        case FETCH_USER_DATA_SUCCESS:
            let updateUserData;
            if (state.userData && statusSuccess(state.userData)) {
                updateUserData = swcHelpers.objectSpread({}, state.userData.result, action.payload);
            } else {
                updateUserData = action.payload;
            }
            return swcHelpers.objectSpread({}, state, {
                userData: successState(updateUserData)
            });
        case UPDATE_USER_DATA:
            return swcHelpers.objectSpread({}, state, {
                updateCalls: swcHelpers.objectSpread({}, state.updateCalls, {
                    [action.payload.formName]: loadingState()
                })
            });
        case UPDATE_USER_DATA_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                userData: successState(action.payload.server),
                updateCalls: swcHelpers.objectSpread({}, state.updateCalls, {
                    [action.payload.formName]: idleState()
                })
            });
        case UPDATE_USER_DATA_FAILED:
            return swcHelpers.objectSpread({}, state, {
                updateCalls: swcHelpers.objectSpread({}, state.updateCalls, {
                    [action.payload.formName]: failedState(action.payload.error)
                })
            });
    }
    return state;
}

const initialState = {
    state: AuthState.Uninitialized
};
function fail(union) {
    throw new Error(`Should also account for ${union}`);
}
// this is to set the global state of auth package (store)
function reducer(state = initialState, action) {
    switch(action.type){
        case INIT:
            const { apiUrl , domain , clientId , customDomain , routes , basePath , optIns =[] , userSettings ={
                optInsState: initialState$2,
                userDataState: initialState$1
            } , checkoutRoute , putPrescriptionTokensOnCart =false , disableAddressEditing =false ,  } = action.payload;
            return {
                state: AuthState.Initialized,
                apiUrl,
                domain,
                clientId,
                customDomain,
                routing: {
                    basePath,
                    routes,
                    checkoutRoute
                },
                optIns,
                userSettings,
                loginCall: idleState(),
                signupCall: idleState(),
                resetPasswordCall: idleState(),
                putPrescriptionTokensOnCart,
                disableAddressEditing
            };
        case SET_PASSWORD:
            if (!isLoggedInPasswordless(state)) {
                throw new Error(`Can only dispatch ${SET_PASSWORD} when user is logged in with passwordless flow`);
            }
            return swcHelpers.objectSpread({}, state, {
                activateCall: loadingState()
            });
        case SET_PASSWORD_FAILED:
            const { error  } = action;
            if (!isLoggedInPasswordless(state)) {
                throw new Error(`Can only dispatch ${SET_PASSWORD_FAILED} when user is logged in with passwordless flow`);
            }
            return swcHelpers.objectSpread({}, state, {
                activateCall: failedState(error)
            });
        case SET_PASSWORD_SUCCESS:
            if (!isLoggedInPasswordless(state)) {
                throw new Error(`Can only dispatch ${SET_PASSWORD_SUCCESS} when user is logged in with passwordless flow`);
            }
            return swcHelpers.objectSpread({}, state, {
                activateCall: idleState(),
                hasActivatedAccount: true
            });
        case SIGNUP:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                signupCall: loadingState()
            });
        case SIGNUP_SUCCESS:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                signupCall: idleState()
            });
        case SIGNUP_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                signupCall: failedState(action.error)
            });
        case RESET_PASSWORD:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                resetPasswordCall: loadingState()
            });
        case RESET_PASSWORD_SUCCESS:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                resetPasswordCall: idleState()
            });
        case RESET_PASSWORD_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                resetPasswordCall: failedState(action.error)
            });
        case UPDATE_PASSWORD:
            if (!isLoggedInPasswordless(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                setPasswordCall: loadingState()
            });
        case UPDATE_PASSWORD_FAILED:
            if (!isLoggedInPasswordless(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                setPasswordCall: failedState(action.error)
            });
        case UPDATE_PASSWORD_SUCCESS:
            if (!isLoggedInPasswordless(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                setPasswordCall: idleState()
            });
        case CHANGE_PASSWORD:
            if (!isLoggedIn$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                changePasswordCall: loadingState()
            });
        case CHANGE_PASSWORD_FAILED:
            if (!isLoggedIn$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                changePasswordCall: failedState(action.error)
            });
        case CHANGE_PASSWORD_SUCCESS:
            if (!isLoggedIn$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            /**
       * We don't want to set this call from loading state back to idle state because we want to keep the submit button
       * in loading state. The finished call will trigger a redirect which will refresh the page and also reset this
       * part of the Redux store, since it's not persisted.
       */ return state;
        case LOGIN:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                loginCall: loadingState()
            });
        case LOGIN_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                loginCall: failedState(action.error)
            });
        case PARSE_HASH_SUCCEEDED:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            switch(action.payload.type){
                default:
                    return fail(action.payload);
                case 'regular':
                    return swcHelpers.objectSpread({}, state, {
                        state: AuthState.LoggedIn,
                        userId: action.payload.id,
                        email: action.payload.email,
                        type: 'regular',
                        loginCall: idleState(),
                        changePasswordCall: idleState()
                    });
                case 'passwordless':
                    return swcHelpers.objectSpread({}, state, {
                        state: AuthState.LoggedIn,
                        userId: action.payload.id,
                        email: action.payload.email,
                        type: 'passwordless',
                        loginCall: idleState(),
                        hasActivatedAccount: action.payload.hasActivatedAccount,
                        activateCall: idleState(),
                        setPasswordCall: idleState()
                    });
            }
        case PARSE_HASH_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            return swcHelpers.objectSpread({}, state, {
                state: AuthState.ParseHashFailed,
                error: action.payload.error,
                email: action.payload.email
            });
        case RECOVER_SESSION_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error(`Can't run actions before auth is initialized`);
            }
            if (isLoggedIn$1(state) || isLoggedInPasswordless(state)) {
                // We don't care session recovery has failed if we're logged in anyway
                return state;
            }
            return swcHelpers.objectSpread({}, state, {
                state: AuthState.LoggedOut,
                error: action.error
            });
    }
    if (isLoggedIn$1(state)) {
        return swcHelpers.objectSpread({}, state, {
            userSettings: {
                optInsState: optInsReducer(state.userSettings.optInsState, action),
                userDataState: userDataReducer(state.userSettings.userDataState, action)
            }
        });
    }
    return state;
}

let webAuth;
let authOptions;
const dbConnection = 'Username-Password-Authentication';
/**
 * Some assertions that provide a clear error message when you've forgot to call init before other operations
 */ const assertInit = {
    isInitialized () {
        if (!webAuth) {
            return new Error("WebAuth hasn't been initialized. Make sure you call `init` before any other operations.");
        }
    },
    throwIfUninitialized () {
        const error = assertInit.isInitialized();
        if (error !== undefined) {
            throw error;
        }
    },
    rejectIfUninitialized (callback) {
        return swcHelpers.asyncToGenerator(function*() {
            const error = assertInit.isInitialized();
            if (error) {
                return Promise.reject(error);
            }
            return new Promise(callback);
        })();
    }
};
/**
 * If the token is about to expire a RenewalRequired action will be published on this channel.
 * Refreshing the token is up to the consumer. A call to `checkSession` will get a fresh token.
 */ const renewalRequired = channel(buffers.none());
let renewalTimeoutToken;
function scheduleRenewal(expiresIn) {
    window.clearTimeout(renewalTimeoutToken);
    renewalTimeoutToken = window.setTimeout(()=>{
        renewalRequired.put({
            type: '@@auth/RENEWAL_REQUIRED'
        });
    }, expiresIn * 1000 - 5000) // Request renewal 5s before it expires
    ;
}
/**
 * Creates a new WebAuth instance. Should be called at least once
 */ function init(options) {
    authOptions = options;
    webAuth = new WebAuth(authOptions);
}
/**
 * Wraps WebAuth.checkSession, see: https://auth0.github.io/auth0.js/global.html#checkSession
 *
 * It can be used to keep a session alive or continue on open one (say, after a page refresh)
 * Will also schedule a renewal event, see the `renewalRequired` channel at the top of the module
 */ function checkSession$1() {
    return _checkSession.apply(this, arguments);
}
function _checkSession() {
    _checkSession = swcHelpers.asyncToGenerator(function*(options = {}) {
        return assertInit.rejectIfUninitialized((resolve, reject)=>{
            webAuth.checkSession(options, (err, authResult)=>{
                if (err) {
                    reject(err);
                    return;
                }
                if (!authResult) {
                    reject(new Error(`Failed to checkSession, authResult was null`));
                    return;
                }
                if (authResult.expiresIn) {
                    scheduleRenewal(authResult.expiresIn);
                }
                resolve(authResult);
            });
        });
    });
    return _checkSession.apply(this, arguments);
}
/**
 * Wraps webAuth.crossOriginAuthentication, see: https://auth0.github.io/auth0.js/global.html#login
 * (search for cross-origin-authentication to find the correct type of login)
 *
 * Logs in the user with username and password using the cross origin authentication flow
 */ function crossOriginAuthentication(email, password) {
    return _crossOriginAuthentication.apply(this, arguments);
}
function _crossOriginAuthentication() {
    _crossOriginAuthentication = swcHelpers.asyncToGenerator(function*(email, password, options = {}) {
        return assertInit.rejectIfUninitialized((resolve, reject)=>{
            webAuth.login(swcHelpers.objectSpread({}, options, {
                username: email,
                realm: dbConnection,
                password,
                // @ts-ignore (types of auth0-js package are not complete
                responseType: 'token id_token',
                state: JSON.stringify({
                    email
                })
            }), (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(result);
            });
        });
    });
    return _crossOriginAuthentication.apply(this, arguments);
}
/**
 * Wraps WebAuth.parseHash, see: https://auth0.github.io/auth0.js/global.html#parseHash
 *
 * This function should be called on the returnUri (ie, the page that auth0 sends the user back to)
 * Will also schedule a renewal event, see the `renewalRequired` channel at the top of the module
 */ function parseHash$1(options) {
    return _parseHash.apply(this, arguments);
}
function _parseHash() {
    _parseHash = swcHelpers.asyncToGenerator(function*(options) {
        return assertInit.rejectIfUninitialized((resolve, reject)=>{
            const callback = (err, authResult)=>{
                if (err) {
                    reject(err);
                    return;
                }
                if (!authResult) {
                    reject(new Error(`Failed to parseHash, authResult was '${authResult}'`));
                    return;
                }
                if (authResult.expiresIn) {
                    scheduleRenewal(authResult.expiresIn);
                }
                resolve(authResult);
            };
            if (options) {
                webAuth.parseHash(options, callback);
            } else {
                webAuth.parseHash(callback);
            }
        });
    });
    return _parseHash.apply(this, arguments);
}
/**
 * Wraps WebAuth.client.userInfo, see: https://auth0.github.io/auth0.js/global.html#userInfo
 */ function userInfo(accessToken) {
    return _userInfo.apply(this, arguments);
}
function _userInfo() {
    _userInfo = swcHelpers.asyncToGenerator(function*(accessToken) {
        if (!accessToken) {
            throw new Error('accessToken needs to be non-empty');
        }
        return assertInit.rejectIfUninitialized((resolve, reject)=>{
            webAuth.client.userInfo(accessToken, (err, userResult)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(userResult);
            });
        });
    });
    return _userInfo.apply(this, arguments);
}
/**
 * Wraps WebAuth.logout, see: https://auth0.github.io/auth0.js/global.html#logout
 */ function logout(returnTo) {
    assertInit.throwIfUninitialized();
    window.clearTimeout(renewalTimeoutToken);
    // Redirects out
    webAuth.logout({
        returnTo
    });
}

const audience = 'fake_https://api.local:3080/';
let tokenCache = {};
const createTokenKey = (audience1, scopes)=>`${audience1}::${scopes}`
;
const cacheToken = (accessToken)=>{
    const token = jwtDecode(accessToken);
    const tokenKey = createTokenKey(Array.isArray(token.aud) ? token.aud.join(' ') : token.aud, token.scope);
    const timeoutToken = cacheTokenWithLifetime(tokenKey, token.exp);
    tokenCache[tokenKey] = {
        token: accessToken,
        clearTimeoutToken: timeoutToken
    };
};
const clearTokenCache = ()=>{
    tokenCache = {};
};
const cacheTokenWithLifetime = (tokenKey, expiresIn)=>{
    return window.setTimeout(()=>{
        if (tokenKey in tokenCache) {
            delete tokenCache[tokenKey];
        }
    }, expiresIn * 1000 - 5000);
};
const getToken = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(...scopes) {
        const scopeString = scopes.join(' ');
        const tokenKey = createTokenKey(audience, scopeString);
        if (tokenKey in tokenCache) {
            return tokenCache[tokenKey].token;
        }
        const authResult = yield checkSession$1({
            audience,
            scope: scopeString,
            responseType: 'token'
        });
        if (!authResult.accessToken) {
            throw new Error(`Did not receive accessToken from Auth0`);
        }
        if (!authResult.expiresIn) {
            throw new Error(`Did not receive accessToken expiry, received '${authResult.expiresIn}'`);
        }
        cacheToken(authResult.accessToken);
        return authResult.accessToken;
    });
    return function getToken() {
        return _ref.apply(this, arguments);
    };
}();

const getCustomerUri = (apiUrl, customerId)=>`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}`
;
const getAccountUri = (apiUrl)=>`${apiUrl}/customers/account`
;
const unwrapResponse = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(response) {
        if (!response.ok) {
            let result = '';
            try {
                result = yield response.text();
            } catch (e) {}
            throw new Error(`Got non OK response from server: ${response.status} ${response.statusText}: ${result}`);
        }
        return response.json();
    });
    return function unwrapResponse(response) {
        return _ref.apply(this, arguments);
    };
}();
const baseOptions = {
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-cache'
};
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ const optIns = {
    /**
   * @deprecated use the new GQL hook
   * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
   */ fetch (apiUrl, customerId) {
        return swcHelpers.asyncToGenerator(function*() {
            const accessToken = yield getToken();
            return unwrapResponse((yield fetch(`${getCustomerUri(apiUrl, customerId)}/optins`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'GET',
                headers: new Headers({
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                })
            }))));
        })();
    },
    /**
   * @deprecated use the new GQL hook
   * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
   */ update (apiUrl, customerId, optinUpdates) {
        return swcHelpers.asyncToGenerator(function*() {
            const accessToken = yield getToken();
            return unwrapResponse((yield fetch(`${getCustomerUri(apiUrl, customerId)}/optins`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'POST',
                headers: new Headers({
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    optinUpdates
                })
            }))));
        })();
    }
};
const account = {
    signup (apiUrl, loginRedirectUrl, emailAddress, additionalAccountData, reason) {
        return swcHelpers.asyncToGenerator(function*() {
            const { personalDetails ={} , optins ={}  } = additionalAccountData;
            const optInsUpdate = Object.keys(optins).length > 0 ? optins : undefined;
            const additionalData = {
                personalDetails,
                optins: optInsUpdate
            };
            const locale = LocaleUtils.getLocaleFromCookie();
            const stateParams = {
                targetAction: 'signUp'
            };
            let body = swcHelpers.objectSpread({
                loginRedirectUrl,
                emailAddress,
                state: JSON.stringify(stateParams),
                reason
            }, additionalData);
            body = locale ? swcHelpers.objectSpread({}, body, {
                locale
            }) : body;
            return unwrapResponse((yield fetch(`${getAccountUri(apiUrl)}/create`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
                body: JSON.stringify(body)
            }))));
        })();
    },
    activate (apiUrl, accessToken, accountId, emailAddress, password, consents1) {
        return swcHelpers.asyncToGenerator(function*() {
            const locale = LocaleUtils.getLocaleFromCookie();
            let body = {
                emailAddress,
                password,
                consents: consents1
            };
            body = locale ? swcHelpers.objectSpread({}, body, {
                locale
            }) : body;
            return unwrapResponse((yield fetch(`${getAccountUri(apiUrl)}/activate/${encodeURIComponent(accountId)}`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'POST',
                headers: new Headers({
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(body)
            }))));
        })();
    },
    changePassword (apiUrl, accessToken, accountId, password) {
        return swcHelpers.asyncToGenerator(function*() {
            return unwrapResponse((yield fetch(`${getAccountUri(apiUrl)}/changepassword/${encodeURIComponent(accountId)}`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'POST',
                headers: new Headers({
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    password
                })
            }))));
        })();
    }
};

function* activateAccount(action) {
    const authState = yield select(getAuth);
    if (!isLoggedInPasswordless(authState)) {
        throw new Error('User needs to be logged-in with passwordless connection');
    }
    try {
        const token = yield call(getToken, 'openid', 'email');
        yield call([
            account,
            'activate'
        ], authState.apiUrl, token, authState.userId, authState.email, action.payload.password, action.payload.consents);
        yield put(setPasswordSuccess({
            userId: authState.userId,
            password: action.payload.password,
            email: authState.email,
            consents: action.payload.consents
        }));
    } catch (err) {
        yield put(setPasswordFailed(err));
    }
}
function* loginAfterAccountActivation(action) {
    const authState = yield select(getAuth);
    if (!isLoggedInPasswordless(authState)) {
        return;
    }
    try {
        yield put(loginWithPassword({
            email: action.payload.email,
            password: action.payload.password
        }));
        yield call(toast.success, 'account.setPassword.success');
    } catch (err) {
        yield put(setPasswordFailed(err));
    }
}
function* signupPasswordless(action) {
    const authState = yield select(getAuth);
    if (isUninitialized$1(authState)) {
        throw new Error(`Can't do signup when auth hasn't been initialized first`);
    }
    try {
        const { email , personalDetails , selectedOptIns , reason  } = action.payload;
        const optInUpdates = yield call(createOptInsUpdate, selectedOptIns);
        const { protocol , host  } = window.location;
        const redirectUri = `${protocol}//${host}/${authState.routing.basePath}/callback`;
        const result = yield call([
            account,
            'signup'
        ], authState.apiUrl, redirectUri, email, {
            personalDetails,
            optins: optInUpdates
        }, reason);
        yield put(signUpSuccess({
            email: action.payload.email,
            id: result.accountId,
            accountDataToken: result.accountDataToken
        }));
        yield call(toast.success, 'account.activationEmail.success');
    } catch (err) {
        yield put(signUpFailed(err));
    }
}
var createAccountSagas = [
    takeLatest(SET_PASSWORD, activateAccount),
    takeLatest(SET_PASSWORD_SUCCESS, loginAfterAccountActivation),
    takeLatest(SIGNUP, signupPasswordless), 
];

function isExpiredLinkError(error) {
    if ('error' in error) {
        const description = error.error_description || error.errorDescription;
        if (description === null || description === void 0 ? void 0 : description.toLowerCase().includes('the verification code has expired')) {
            return true;
        }
        // For an already activated account we inform the user the same as for an expired link
        if (description === null || description === void 0 ? void 0 : description.toLowerCase().includes('wrong email or verification code')) {
            return true;
        }
    }
    return false;
}

function* login(action) {
    const { returnPath  } = action.payload;
    try {
        if (window && returnPath) {
            try {
                yield call([
                    sessionStorage,
                    'setItem'
                ], 'login_returnPath', returnPath);
            } catch (e) {
                console.error(`Setting path to storage failed. Error: ${e}`);
            }
        }
        yield call(crossOriginAuthentication, action.payload.email, action.payload.password, {
            scope: 'openid profile email'
        });
    } catch (err) {
        yield put(loginFailed(err));
    }
}
const stateSpec = Type.interface({
    accountVerificationMethod: optional(Type.string),
    email: optional(Type.string),
    targetAction: optional(Type.literal({
        forgotPassword: 1,
        signUp: 1
    }))
});
function parseState(state) {
    try {
        const result = JSON.parse(state);
        return verify(stateSpec, result).value();
    } catch (err) {
        return undefined;
    }
}
function* parseHash() {
    let state = 'TODO:csrf';
    try {
        var ref;
        try {
            const hash = QueryString.parse(window.location.hash.substring(1));
            if (hash.state) {
                state = StringGuard.guard('hash.state', hash.state);
            }
        } catch (e) {
            console.error('Error while parsing URL hash:', e);
        }
        const result = yield call(parseHash$1, {
            state
        });
        if (!result.accessToken) {
            yield put(parseHashFailed(swcHelpers.objectSpread({
                error: new Error('No accessToken received after login')
            }, parseState(state))));
            return;
        }
        const accountVerificationMethod = (ref = parseState(state)) === null || ref === void 0 ? void 0 : ref.accountVerificationMethod;
        yield call(onAccessTokenReceived, result.accessToken, true, accountVerificationMethod);
    } catch (error) {
        yield put(parseHashFailed(swcHelpers.objectSpread({
            error
        }, parseState(state))));
    }
}
function* redirectAfterParseHash(action) {
    if (!action.payload.redirect) {
        return;
    }
    const routes = yield select(getFormattedRoutes);
    if (!routes) {
        throw new Error('Need routes to redirect');
    }
    let route = RouteKey.Profile;
    if (action.payload.type === 'passwordless') {
        if (action.payload.hasActivatedAccount) {
            route = RouteKey.SetPassword;
        } else if (action.payload.accountVerificationMethod === 'dateOfBirth') {
            route = RouteKey.Verify;
        } else {
            route = RouteKey.CreateAccount;
        }
    } else {
        const returnPath = yield call([
            sessionStorage,
            'getItem'
        ], 'login_returnPath');
        if (returnPath) {
            yield put(goto({
                path: decodeURIComponent(returnPath)
            }));
            yield call([
                sessionStorage,
                'removeItem'
            ], 'login_returnPath');
            return;
        }
    }
    yield put(goto({
        route
    }));
}
/**
 * If the user comes in passwordless and the link has expired, redirect
 * to 'link-expired' so they can request a new link
 */ function* redirectAfterFailedParseHash(action) {
    const routes = yield select(getFormattedRoutes);
    if (!routes) {
        throw new Error('Need routes to redirect');
    }
    const { error , targetAction  } = action.payload;
    const query = {};
    if ('error' in error) {
        const description = error.error_description || error.errorDescription;
        if (description && description.startsWith('gv__')) {
            query.error = description.substring('gv__'.length);
        }
    }
    let redirectRoute = RouteKey.Login;
    if (targetAction === 'forgotPassword' || targetAction === 'signUp') {
        redirectRoute = RouteKey.LinkExpired;
        query.targetAction = targetAction;
    } else if (isExpiredLinkError(error)) {
        redirectRoute = RouteKey.LinkExpired;
    }
    yield put(goto({
        route: redirectRoute,
        query: Object.keys(query).length > 0 ? QueryString.stringify(query, true) : undefined
    }));
}
function* checkSession() {
    const authState = yield select(getAuth);
    if (isUninitialized$1(authState)) {
        return;
    }
    const result = yield call(checkSession$1, {
        scope: 'openid profile',
        responseType: 'id_token token'
    });
    if (!result.accessToken) {
        throw new Error('No accessToken received during session recovery');
    }
    return result;
}
function* redirectOnFailedSession() {
    yield call(removeUserDataFromLS);
    yield call(clearTokenCache);
    yield put(logOut$1());
}
function* assertSession() {
    let error;
    try {
        const result = yield call(checkSession);
        if (!(result === null || result === void 0 ? void 0 : result.accessToken)) {
            yield call(redirectOnFailedSession);
            error = new Error('No access token received during session assertion.');
        }
    } catch (err) {
        /**
     * The user might have internet troubles when an error is caught here, so we need to check the
     * nature of the error. If the error is because of re-login being required, we can redirect them out.
     */ if (err.error === 'login_required') {
            yield call(redirectOnFailedSession);
            error = new Error('No access token received during session assertion.');
        } else {
            /**
       * In any other case we don't know what the error is, and we don't know if we should log the user out.
       */ error = err;
        }
    }
    if (error) {
        yield put(assertSessionFailed(error));
    }
}
function* recoverSession() {
    try {
        const result = yield call(checkSession);
        if (!(result === null || result === void 0 ? void 0 : result.accessToken)) {
            yield put(recoverSessionFailed(new Error('No accessToken received during session recovery')));
            yield call(DataLayer.setUserObjectDataLayer, false);
            return;
        }
        yield call(onAccessTokenReceived, result.accessToken, false);
        yield call(DataLayer.setUserObjectDataLayer, true);
    } catch (err) {
        yield put(recoverSessionFailed(err));
        yield call(DataLayer.setUserObjectDataLayer, false);
    }
}
function* onAccessTokenReceived(accessToken, redirect, accountVerificationMethod) {
    const jwtContent = yield call(jwtDecode, accessToken);
    let email = jwtContent['https://grandvision/claims/email'];
    if (!email) {
        const userInfo$1 = yield call(userInfo, accessToken);
        if (!userInfo$1.email) {
            throw new Error(`Email claim should be in accessToken or accessToken should have at least 'openid email' scope`);
        }
        email = userInfo$1.email;
    }
    yield call(cacheToken, accessToken);
    const opts = {
        id: jwtContent.sub,
        email,
        redirect
    };
    if (jwtContent['https://grandvision/claims/connection'] === 'email') {
        yield put(parseHashSucceeded(swcHelpers.objectSpread({}, opts, {
            type: 'passwordless',
            hasActivatedAccount: jwtContent['https://grandvision/claims/activeAccount'] || false,
            accountVerificationMethod
        })));
    } else {
        yield put(parseHashSucceeded(swcHelpers.objectSpread({}, opts, {
            type: 'regular'
        })));
    }
}
var loginSagas = [
    takeLatest(LOGIN, login),
    takeLatest(PARSE_HASH, parseHash),
    takeLatest(PARSE_HASH_SUCCEEDED, redirectAfterParseHash),
    takeLatest(PARSE_HASH_FAILED, redirectAfterFailedParseHash),
    takeLeading(RECOVER_SESSION, recoverSession),
    takeLeading(ASSERT_SESSION, assertSession), 
];

function getReturnPath() {
    const { pathname , search , hash  } = window.location;
    return pathname + search + hash;
}
function* logOut() {
    const basePath = yield select(getBasePath);
    if (!basePath) {
        throw new Error(`Need basePath to generate logout return URI`);
    }
    yield call(logout, `${window.location.protocol}//${location.host}/${basePath}/logged-out?returnPath=${getReturnPath()}`);
}
function* redirectAfterLogOut() {
    yield call(removeUserDataFromLS);
    const { returnPath  } = QueryString.parse(window.location.search);
    const targetPath = isString(returnPath) ? returnPath : '/';
    const historyWrapper = yield call(history);
    try {
        yield call(historyWrapper.replace, {
            pathname: targetPath
        });
        window && window.location.reload();
    } catch (err) {
        console.error(err);
    }
}
var logoutSagas = [
    takeLatest(LOG_OUT, logOut),
    takeLatest(LOGGED_OUT, redirectAfterLogOut), 
];

/** @deprecated use the new GQL hook use-opt-ins.ts */ function* fetchOptIns() {
    try {
        const auth = yield select(getAuth);
        if (!isLoggedIn$1(auth)) {
            throw new Error(`Can't fetch opt-ins when user isn't logged in`);
        }
        const result = yield call([
            optIns,
            'fetch'
        ], auth.apiUrl, auth.userId);
        yield put(fetchOptInsSuccess(result));
    } catch (err) {
        yield put(fetchOptInsFailed(err));
    }
}
/** @deprecated use the new GQL hook use-opt-ins.ts */ function* updateOptIns(action) {
    try {
        const auth = yield select(getAuth);
        if (!isLoggedIn$1(auth)) {
            throw new Error(`Can't fetch opt-ins when user isn't logged in`);
        }
        /**
     * This saga handles 2 scenarios:
     *  1. Changed opt-ins are coming from outside the auth state, so they are passed as payload of the action
     *  2. Changed opt-ins are set within the auth state, meaning we can use a selector to grab them from the state
     */ let changedOptIns = action.payload;
        if (changedOptIns === undefined) {
            changedOptIns = yield select(getChangedOptIns);
        }
        // Convert to opt-in update model
        const updates = yield call(createOptInsUpdate, changedOptIns);
        if (Object.keys(updates).length > 0) {
            // Get opt-ins state from server
            const serverOptInsState = yield call([
                optIns,
                'fetch'
            ], auth.apiUrl, auth.userId);
            // Diff what is actually an opt-in update
            const diff = Object.entries(updates).reduce((acc, [key, optIn])=>(serverOptInsState.optinValues || {})[key] !== optIn.value ? swcHelpers.objectSpread({}, acc, {
                    [key]: optIn
                }) : acc
            , {});
            if (Object.keys(diff).length > 0) {
                yield call([
                    optIns,
                    'update'
                ], auth.apiUrl, auth.userId, diff);
            }
            yield put(updateOptInsSuccess());
            yield call(toast.success, 'account.updateOptins.success');
        }
    } catch (err) {
        yield put(updateOptInsFailed(err));
    }
}
/** @deprecated use the new GQL hook use-opt-ins.ts */ var optInSagas = [
    takeLatest(FETCH_OPT_INS, fetchOptIns),
    takeLatest(UPDATE_OPT_INS, updateOptIns), 
];

const getAuth0ErrorCode = (errorString)=>{
    const regex = /"auth0ErrorCode":"(\w+)"/;
    const result = regex.exec(errorString);
    return result && result[1] ? result[1] : undefined;
};

function* onResetPassword(action) {
    const authState = yield select(getAuth);
    try {
        const stateParams = {
            targetAction: 'forgotPassword'
        };
        const { protocol , host  } = window === null || window === void 0 ? void 0 : window.location;
        const redirectUri = `${protocol}//${host}/${authState.routing.basePath}/callback`;
        const requestPayload = {
            emailAddress: action.payload.email,
            state: JSON.stringify(stateParams),
            loginRedirectUrl: redirectUri
        };
        yield call(Customers.Password.resetPassword, authState.apiUrl, requestPayload);
        yield put(resetPasswordSuccess({
            email: action.payload.email
        }));
        yield call(toast.success, 'account.resetPassword.success');
    } catch (err) {
        yield put(resetPasswordFailed(err));
    }
}
function* onUpdatePassword(action) {
    const authState = yield select(getAuth);
    if (!isLoggedInPasswordless(authState)) {
        yield put(updatePasswordFailed(new Error(`Can only update users' password when they're logged-in with passwordless link`)));
        return;
    }
    const token = yield call(getToken, 'gv::update:password', 'email', 'profile', 'openid');
    try {
        yield call(account.changePassword, authState.apiUrl, token, authState.userId, action.payload.password);
        yield put(updatePasswordSuccess({
            password: action.payload.password
        }));
        yield call(toast.success, 'account.updatePassword.success');
    } catch (err) {
        yield put(updatePasswordFailed(err));
    }
}
const convertPayload = (payload)=>({
        email: payload.email,
        oldPassword: payload.currentPassword,
        password: payload.newPassword
    })
;
function* onChangePassword(action) {
    const authState = yield select(getAuth);
    if (!isLoggedIn$1(authState)) {
        yield put(changePasswordFailed(new Error(`Can only update users' password when they're logged-in`)));
        return;
    }
    const changePasswordPayload = convertPayload(action.payload);
    try {
        const token = yield call(getToken);
        yield call(Customers.Password.changePassword, authState.apiUrl, token, authState.userId, changePasswordPayload);
        yield put(changePasswordSuccess({
            password: changePasswordPayload.password
        }));
    } catch (err) {
        // Get auth0ErrorCode value from error string, if it exists
        const auth0ErrorCode = (err === null || err === void 0 ? void 0 : err.message) ? getAuth0ErrorCode(err.message) : undefined;
        yield put(changePasswordFailed(auth0ErrorCode || err));
    }
}
function* loginAfterPasswordUpdate(action) {
    const authState = yield select(getAuth);
    if (!isLoggedInPasswordless(authState)) {
        console.error(`User is not logged in via passwordless method. Login state: ${authState.state}. Login type: ${authState.type}.`);
        return;
    }
    yield call(crossOriginAuthentication, authState.email, action.payload.password);
}
function* loginAfterPasswordChange(action) {
    const authState = yield select(getAuth);
    const routing = yield select(getRouting);
    if (!isLoggedIn$1(authState)) {
        console.error(`User is not regularly logged in. Login state: ${authState.state}. Login type: ${authState.type}.`);
        return;
    }
    const returnPath = routing && encodeURIComponent(routing.basePath + '/' + routing.routes.changePassword + '?changePasswordResult=success');
    yield put(loginWithPassword({
        email: authState.email,
        password: action.payload.password,
        returnPath
    }));
}
var resetPasswordSagas = [
    takeLatest(RESET_PASSWORD, onResetPassword),
    takeLatest(UPDATE_PASSWORD, onUpdatePassword),
    takeLatest(CHANGE_PASSWORD, onChangePassword),
    takeLatest(CHANGE_PASSWORD_SUCCESS, loginAfterPasswordChange),
    takeLatest(UPDATE_PASSWORD_SUCCESS, loginAfterPasswordUpdate), 
];

function* fetchUserData() {
    const auth = yield select(getAuth);
    if (!isLoggedIn$1(auth)) {
        throw new Error(`Can't fetch user data when not logged in`);
    }
    try {
        const token = yield call(getToken);
        const response = yield call(Customers.details, auth.apiUrl, token, auth.userId);
        yield put(fetchUserDataSuccess(response.personalDetails));
    } catch (err) {
        yield put(fetchUserDataFailed(err));
    }
}
function* updateUserData(action) {
    const { formName , formData  } = action.payload;
    const auth = yield select(getAuth);
    const userData = yield select(getUserData);
    if (!isLoggedIn$1(auth)) {
        throw new Error(`Can't fetch user data when not logged in`);
    }
    if (userData && statusSuccess(userData)) {
        const updatedUserData = swcHelpers.objectSpread({}, userData.result, {
            [formName]: formData
        });
        try {
            const token = yield call(getToken);
            yield call(Customers.updateDetails, auth.apiUrl, token, auth.userId, {
                personalDetails: updatedUserData
            });
            yield put(updateUserDataSuccess({
                server: updatedUserData,
                formName
            }));
        } catch (err) {
            yield put(updateUserDataFailed({
                error: err,
                formName
            }));
        }
    }
}
var userDataSagas = [
    takeLatest(FETCH_USER_DATA, fetchUserData),
    takeLatest(UPDATE_USER_DATA, updateUserData), 
];

function* authInit(action) {
    const { domain , customDomain , clientId , basePath  } = action.payload;
    yield call(init, {
        clientID: clientId,
        domain: customDomain || domain,
        audience: 'fake_https://api.local:3080/',
        redirectUri: `${window.location.protocol}//${window.location.host}/${basePath}/callback`
    });
}
function* onGoto(action) {
    if ('path' in action.payload) {
        const pathname = `/${action.payload.path}`.replace('//', '/');
        yield call(redirect, pathname);
        return;
    }
    const routes = yield select(getFormattedRoutes);
    if (!routes) {
        throw new Error('Need routes to redirect');
    }
    const requestedRoute = routes[action.payload.route];
    if (!requestedRoute) {
        throw new Error(`Tried to go to optional route '${action.payload.route}' but it is not set. Formatted routes contained: '${String(requestedRoute)}'`);
    }
    const historyWrapper = yield call(history);
    if (action.payload.query) {
        yield call(historyWrapper.push, {
            pathname: requestedRoute,
            search: action.payload.query
        });
    } else {
        yield call(historyWrapper.push, {
            pathname: requestedRoute
        });
    }
}
function* sagas() {
    yield all([
        ...createAccountSagas,
        ...loginSagas,
        ...logoutSagas,
        ...resetPasswordSagas,
        ...optInSagas,
        ...userDataSagas,
        takeLatest(GOTO, onGoto),
        takeLatest(INIT, authInit), 
    ]);
}

const LABEL_PREFIX = 'account.login';
const ERROR_PREFIX = `${LABEL_PREFIX}.errors`;
var Auth0ErrorCode;
(function(Auth0ErrorCode) {
    Auth0ErrorCode["AccessDenied"] = 'access_denied';
    Auth0ErrorCode["PasswordLeaked"] = 'password_leaked';
})(Auth0ErrorCode || (Auth0ErrorCode = {}));
var UrlStateParamError;
(function(UrlStateParamError) {
    UrlStateParamError["RequiresPasswordChange"] = 'requiresPasswordChange';
})(UrlStateParamError || (UrlStateParamError = {}));
const NonCompliantPasswordMessage = (props)=>{
    const { routes  } = props;
    const { getLabel  } = useIntl();
    const label = getLabel(`${ERROR_PREFIX}.requiresPasswordChange`);
    const handleClick = React.useCallback(()=>{
        props.resetPassword({
            email: props.email || ''
        });
    }, [
        props.resetPassword,
        props.email
    ]);
    /*
   * Look for the [ ] and take the part before, inside and after to create a text with
   * the link inside, like: "before" + <a>"inside"<a/> + "after"
   */ const regex = /(.+)\[(.+)\](.+)/g;
    const linkElement = props.email ? /*#__PURE__*/ React.createElement("button", {
        className: "login__reset-link",
        onClick: handleClick,
        "data-t": "non-compliant-password-action"
    }, label.replace(regex, '$2')) : /*#__PURE__*/ React.createElement("a", {
        className: "login__reset-link",
        href: routes ? routes.resetPassword : '#',
        "data-t": "non-compliant-password-action"
    }, label.replace(regex, '$2'));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", null, label.replace(regex, '$1')), linkElement, /*#__PURE__*/ React.createElement("span", null, label.replace(regex, '$3')));
};
NonCompliantPasswordMessage.displayName = 'NonCompliantPasswordMessage';
const initialFieldState = {
    isTouched: false,
    isValid: false,
    value: ''
};
const Login = ({ auth , email , error , routes , className , loginWithPassword: loginWithPassword1 , createAccountRichText , disableSignup , returnPath , resetPassword: resetPassword1  })=>{
    const { getLabel  } = useIntl();
    const [hasFormValidationError, setHasFormValidationError] = React.useState(false);
    const [loginForm, setLoginForm] = React.useState({
        email: swcHelpers.objectSpread({
            name: 'email'
        }, initialFieldState),
        password: swcHelpers.objectSpread({
            name: 'password'
        }, initialFieldState)
    });
    const formattedError = React.useMemo(()=>{
        if (statusFailed(auth.loginCall)) {
            const { code , error_description , message  } = auth.loginCall.error;
            if (code === Auth0ErrorCode.AccessDenied) {
                return getLabel(`${ERROR_PREFIX}.invalidCredentials`);
            }
            if (code === Auth0ErrorCode.PasswordLeaked) {
                return getLabel(`${ERROR_PREFIX}.passwordLeaked`);
            }
            return error_description || message || '';
        }
        if (error === UrlStateParamError.RequiresPasswordChange) {
            return;
        }
        // If this is true, it is one of the other errors from the URL state parameter
        if (typeof error === 'string') {
            return getLabel(`${ERROR_PREFIX}.${error}`);
        }
        if (hasFormValidationError) {
            return getLabel(`${ERROR_PREFIX}.formValidation`);
        }
    }, [
        error,
        auth.loginCall,
        getLabel,
        hasFormValidationError
    ]);
    const handleSubmit = React.useCallback((state)=>{
        var ref, ref1, ref2, ref3;
        const { formState  } = state;
        if ((formState === null || formState === void 0 ? void 0 : (ref = formState.email) === null || ref === void 0 ? void 0 : ref.isValid) && (formState === null || formState === void 0 ? void 0 : (ref1 = formState.password) === null || ref1 === void 0 ? void 0 : ref1.isValid)) {
            setHasFormValidationError(false);
            loginWithPassword1({
                email: formState.email.value,
                password: formState.password.value,
                returnPath
            });
        }
        if (!(formState === null || formState === void 0 ? void 0 : (ref2 = formState.email) === null || ref2 === void 0 ? void 0 : ref2.isTouched) || !(formState === null || formState === void 0 ? void 0 : (ref3 = formState.password) === null || ref3 === void 0 ? void 0 : ref3.isTouched)) {
            return setLoginForm({
                email: swcHelpers.objectSpread({}, formState.email, {
                    isTouched: true
                }),
                password: swcHelpers.objectSpread({}, formState.password, {
                    isTouched: true
                })
            });
        }
        setHasFormValidationError(true);
    }, [
        loginWithPassword1,
        returnPath,
        hasFormValidationError,
        setHasFormValidationError,
        setLoginForm
    ]);
    const wrapperClasses = classnames('login', className);
    const isLoading = statusLoading(auth.loginCall);
    return /*#__PURE__*/ React.createElement("div", {
        className: wrapperClasses
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("section", {
        className: "login__section"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        className: "login__section__title"
    }, getLabel(`${LABEL_PREFIX}.title`)), !isLoading && formattedError && /*#__PURE__*/ React.createElement(ScrollIntoView, {
        key: formattedError
    }, /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        icon: "info",
        message: formattedError
    })), error === UrlStateParamError.RequiresPasswordChange && /*#__PURE__*/ React.createElement(ScrollIntoView, {
        key: error
    }, /*#__PURE__*/ React.createElement(Alert, {
        type: "warning",
        icon: "info",
        className: "login__non-compliancy-alert"
    }, /*#__PURE__*/ React.createElement(NonCompliantPasswordMessage, {
        routes: routes,
        resetPassword: resetPassword1,
        email: email
    }))), /*#__PURE__*/ React.createElement(Form, {
        onSubmit: handleSubmit,
        initialFormState: loginForm,
        name: "login",
        "data-t": "login-form",
        showErrorsOnInvalidSubmit: false
    }, /*#__PURE__*/ React.createElement(Email, {
        "data-t": "email",
        required: true,
        label: getLabel('fields.input.email.label'),
        errorMessage: getLabel('fields.input.email.errorMessage'),
        hideAsteriskSign: true
    }), /*#__PURE__*/ React.createElement(Password, {
        "data-t": "password",
        required: true,
        label: getLabel('fields.input.password.label'),
        errorMessage: getLabel('fields.input.password.errorMessage'),
        hideAsteriskSign: true
    }), /*#__PURE__*/ React.createElement(Link, {
        className: "login__forgot-password",
        label: getLabel('account.action.resetPassword'),
        url: routes ? routes.resetPassword : '#'
    }), /*#__PURE__*/ React.createElement(Button, {
        "data-t": "submit",
        type: "submit",
        isLoading: isLoading,
        caption: getLabel('account.action.login'),
        className: "login__button"
    }))), !disableSignup && /*#__PURE__*/ React.createElement("section", {
        className: "login__section"
    }, createAccountRichText && /*#__PURE__*/ React.createElement(RichTextArea, {
        content: createAccountRichText
    }), /*#__PURE__*/ React.createElement(Button, {
        "data-t": "create-account",
        variant: "outline",
        caption: getLabel('account.action.createAccount'),
        className: "login__button login__button--signup",
        href: routes ? routes.signup : '#'
    }))));
};
const mapStateToProps$1 = (state)=>({
        auth: getAuth(state),
        routes: getFormattedRoutes(state)
    })
;
const mapDispatchToProps$1 = {
    loginWithPassword,
    resetPassword
};
var Login$1 = connect(mapStateToProps$1, mapDispatchToProps$1)(Login);

const ExpiredLinkView = ({ onResend , titleLabelKey , loginUrl , isLoading , hasError ,  })=>{
    const { getLabel  } = useIntl();
    const [isEmailSent, setIsEmailSent] = React.useState(false);
    const error = React.useMemo(()=>{
        return hasError ? new Error(getLabel('account.createAccount.signup.errors.general')) : undefined;
    }, [
        hasError,
        getLabel
    ]);
    const handleSubmit = React.useCallback((email)=>{
        if (isEmailSent && !hasError || isLoading) {
            return;
        }
        onResend({
            email
        });
        setIsEmailSent(true);
    }, [
        isEmailSent,
        hasError,
        isLoading,
        onResend
    ]);
    const canResend = !isEmailSent || error;
    return /*#__PURE__*/ React.createElement("div", {
        className: "expired-link myaccount__section",
        "data-t": "expired-link"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium"
    }, getLabel(titleLabelKey)), /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        title: getLabel('account.linkExpired.title'),
        message: getLabel('account.linkExpired.message')
    }), error && /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        message: formatError(error)
    }), /*#__PURE__*/ React.createElement(EmailForm, {
        onSubmit: handleSubmit,
        emailErrorLabel: getLabel('account.error.emailInvalid'),
        emailLabel: getLabel('fields.input.email.label'),
        buttonLabel: !canResend ? getLabel('account.action.emailSent') : getLabel('account.action.requestLink'),
        isButtonDisabled: !canResend,
        isButtonLoading: isLoading
    }), /*#__PURE__*/ React.createElement("a", {
        href: loginUrl,
        "data-t": "to-login",
        className: "expired-link__text"
    }, getLabel('account.action.returnToLogin')));
};

const ExpiredLink = ({ targetAction  })=>{
    const { resetPasswordCall , signupCall  } = useSelector(getAuth);
    const routes = useSelector(getFormattedRoutes);
    const loginUrl = (routes === null || routes === void 0 ? void 0 : routes.login) || '#';
    const dispatch = useDispatch();
    const expiredLinkProps = React.useMemo(()=>{
        if (targetAction === 'forgotPassword') {
            return {
                onResend: (payload)=>{
                    dispatch(resetPassword(payload));
                },
                titleLabelKey: 'account.resetPassword.submitEmailAddress.title',
                loginUrl,
                isLoading: statusLoading(resetPasswordCall),
                hasError: statusFailed(resetPasswordCall)
            };
        } else {
            return {
                onResend: (payload)=>{
                    dispatch(signup(payload));
                },
                titleLabelKey: 'account.createAccount.title',
                loginUrl,
                isLoading: statusLoading(signupCall),
                hasError: statusFailed(signupCall)
            };
        }
    }, [
        targetAction,
        signupCall,
        resetPasswordCall,
        statusLoading,
        statusFailed,
        loginUrl,
        resetPassword,
        signup, 
    ]);
    return /*#__PURE__*/ React.createElement(ExpiredLinkView, swcHelpers.extends({}, expiredLinkProps));
};

class Callback extends React.Component {
    componentDidMount() {
        if (this.props.type === 'callback') {
            this.props.parseHash();
        } else {
            this.props.loggedOut();
        }
    }
    render() {
        return /*#__PURE__*/ React.createElement(LoaderScreen, {
            height: 50
        });
    }
}

const LoggedIn = ({ auth , disableContinue , onLogoutClick , onContinueClick ,  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "logged-in__container"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        className: "checkout-step__title logged-in__title"
    }, getLabel('account.alreadyLoggedIn.title')), /*#__PURE__*/ React.createElement("p", null, getFormattedLabel('account.alreadyLoggedIn.text', {
        labelData: {
            email: auth.email
        }
    })), !disableContinue && /*#__PURE__*/ React.createElement(Button, {
        className: "logged-in__button logged-in__button-continue",
        "data-t": "continue",
        caption: getLabel('common.actions.continue'),
        onClick: onContinueClick
    }), /*#__PURE__*/ React.createElement(Button, {
        className: "logged-in__button logged-in__button-logout",
        "data-t": "logout",
        caption: getLabel('account.action.logout'),
        onClick: onLogoutClick,
        variant: "outline"
    }));
};
const mapStateToProps = (state)=>({
        auth: getAuth(state)
    })
;
const mapDispatchToProps = {
    onLogoutClick: logOut$1
};
var LoggedIn$1 = connect(mapStateToProps, mapDispatchToProps)(LoggedIn);

function getActivePath() {
    const url = new URL(window.location.href);
    return url.pathname;
}
const hrefToUrl = (href)=>new URL(`${window.location.origin}${href}`)
;
const getMyAccountMenuItems = (logout, routes, intl, isUserLoggedIn, isAddressBookEnabled, isAabEnabled, isSubscriptionsV2Enabled, onNavigate)=>{
    const activePath = getActivePath();
    const navigate = (href)=>{
        return (e)=>{
            if (isModifiedClickEvent(e)) {
                return;
            }
            e.preventDefault();
            const url = hrefToUrl(href);
            onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(url);
        };
    };
    const logoutItem = {
        label: intl.getLabel('account.menu.logOut'),
        parameters: {
            icon: 'logout',
            action: logout,
            testId: 'logout'
        },
        childMenuItems: [],
        link: {
            href: '',
            type: 'external'
        }
    };
    const loginItem = {
        label: intl.getLabel('account.action.login'),
        childMenuItems: [],
        parameters: {
            testId: 'login'
        },
        link: {
            href: routes.login,
            type: 'external'
        }
    };
    function getProfileChildMenuItems() {
        const items = [];
        if (isAddressBookEnabled) {
            var _addressBook;
            items.push({
                label: intl.getLabel('account.menu.addresses'),
                link: {
                    href: (_addressBook = routes.addressBook) !== null && _addressBook !== void 0 ? _addressBook : '',
                    onClick: routes.addressBook && onNavigate ? navigate(routes.addressBook) : undefined,
                    type: 'external',
                    active: [
                        routes.addressBook
                    ].includes(activePath)
                },
                parameters: {
                    testId: 'addressBook'
                }
            });
        }
        return items;
    }
    const userHasParsedDataFromLS = getParsedDataFromLS();
    let lastItem = logoutItem;
    if (!isUserLoggedIn && !userHasParsedDataFromLS) {
        lastItem = loginItem;
    }
    var _profile, _prescriptions, _orders, _subscriptions, _subscriptionsv2, _settings;
    const items1 = [
        {
            label: intl.getLabel('account.menu.accountDetails'),
            parameters: {
                icon: 'user',
                testId: 'profile'
            },
            link: {
                href: (_profile = routes.profile) !== null && _profile !== void 0 ? _profile : '',
                onClick: routes.profile && onNavigate ? navigate(routes.profile) : undefined,
                type: 'external',
                active: [
                    routes.addressBook,
                    routes.changePassword,
                    routes.profile
                ].includes(activePath)
            },
            childMenuItems: getProfileChildMenuItems()
        },
        {
            label: intl.getLabel('account.menu.appointments'),
            parameters: {
                icon: 'calendar',
                testId: 'appointments'
            },
            link: {
                href: isAabEnabled && routes.appointments || '',
                onClick: routes.appointments && onNavigate ? navigate(routes.appointments) : undefined,
                type: 'external',
                active: routes.appointments === activePath
            }
        },
        {
            label: intl.getLabel('account.menu.prescriptions'),
            parameters: {
                icon: 'frame',
                testId: 'prescriptions'
            },
            link: {
                href: (_prescriptions = routes.prescriptions) !== null && _prescriptions !== void 0 ? _prescriptions : '',
                onClick: routes.prescriptions && onNavigate ? navigate(routes.prescriptions) : undefined,
                type: 'external',
                active: routes.prescriptions === activePath
            }
        },
        {
            label: intl.getLabel('account.menu.orders'),
            parameters: {
                icon: 'orders',
                testId: 'orders'
            },
            link: {
                href: (_orders = routes.orders) !== null && _orders !== void 0 ? _orders : '',
                onClick: routes.orders && onNavigate ? navigate(routes.orders) : undefined,
                type: 'external',
                active: routes.orders === activePath
            }
        },
        {
            label: intl.getLabel('account.menu.subscriptions'),
            parameters: {
                icon: 'shipment-next',
                testId: 'subscriptions'
            },
            link: {
                href: (_subscriptions = routes.subscriptions) !== null && _subscriptions !== void 0 ? _subscriptions : '',
                onClick: routes.subscriptions && onNavigate ? navigate(routes.subscriptions) : undefined,
                type: 'external',
                active: Boolean(routes.subscriptions && !(routes.subscriptionsv2 && activePath.startsWith(routes.subscriptionsv2)) && activePath.startsWith(routes.subscriptions))
            }
        },
        {
            label: `${intl.getLabel('account.menu.subscriptions-v2')}`,
            parameters: {
                icon: 'shipment-next',
                testId: 'subscriptionsv2'
            },
            link: {
                href: isSubscriptionsV2Enabled ? (_subscriptionsv2 = routes.subscriptionsv2) !== null && _subscriptionsv2 !== void 0 ? _subscriptionsv2 : '' : '',
                onClick: routes.subscriptionsv2 && isSubscriptionsV2Enabled && onNavigate ? navigate(routes.subscriptionsv2) : undefined,
                type: 'external',
                active: routes.subscriptionsv2 ? activePath.startsWith(routes.subscriptionsv2) : false
            }
        },
        {
            label: intl.getLabel('account.menu.settings'),
            parameters: {
                icon: 'folded-page-with-text',
                testId: 'settings'
            },
            link: {
                href: (_settings = routes.settings) !== null && _settings !== void 0 ? _settings : '',
                onClick: routes.settings && onNavigate ? navigate(routes.settings) : undefined,
                type: 'external',
                active: routes.settings === activePath
            }
        },
        lastItem, 
    ];
    const hasLink = (item)=>{
        var ref;
        return ((ref = item.link) === null || ref === void 0 ? void 0 : ref.href) && item.link.href !== '';
    };
    const hasAction = (item)=>{
        var ref;
        return (ref = item.parameters) === null || ref === void 0 ? void 0 : ref.action;
    };
    return items1.filter((item)=>hasLink(item) || hasAction(item)
    );
};

const Loader = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SkeletonLoader, {
        className: "myaccount-menu-loader",
        "data-t": "myaccount-menu-loader"
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "16",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "16",
        rx: "5",
        fill: "currentColor"
    })));
};

// Function to check if personalDetails has the required fields from the label
const hasPersonalDetails = (label, personalDetails)=>{
    // If there is not personal data, return false
    if (!personalDetails) {
        return false;
    }
    // Get label parameters
    const matches = label.match(/\{([^}]+)\}/g);
    // If there are no placeholders, we don't need to check anything
    if (!matches) {
        return true;
    }
    //check if personal details has the property
    const parameters = matches.map((match)=>{
        const property = match.replace(/[{}]/g, '');
        if (personalDetails[property]) {
            return true;
        }
        return false;
    });
    //all parameters must be exist in personal details
    return parameters.every((parameter)=>parameter
    );
};
const PersonalizedGreeting = ({ personalDetails , greetingFormatter =()=>undefined
 ,  })=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    const formattedMessage = greetingFormatter({
        data: personalDetails,
        getLabel: getFormattedLabel
    });
    const defaultMessage = hasPersonalDetails(getLabel('account.menu.greeting.withPersonalDetails'), personalDetails) ? getFormattedLabel('account.menu.greeting.withPersonalDetails', {
        labelData: personalDetails
    }) : getLabel('account.menu.greeting.withoutPersonalDetails');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        name: "user-checkmark"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "myaccount-menu-button__label",
        "data-t": "personalized-greeting"
    }, formattedMessage !== null && formattedMessage !== void 0 ? formattedMessage : defaultMessage));
};

const MyAccountMenu = ({ menuItems =[] , greetingFormatter , viewState , personalDetails , className ,  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Flyout, {
        "data-t": "myaccount-menu",
        id: "myaccount-menu",
        className: classnames('myaccount-menu', className)
    }, /*#__PURE__*/ React.createElement(Flyout.Trigger, {
        "data-t": "my-account-menu-button",
        className: classnames('header-menu__icon myaccount-menu-button', className, 'myaccount-menu-button--link'),
        title: getLabel('account.menu.myAccount'),
        "aria-controls": "myaccount-menu"
    }, viewState === 'unknown-user' && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        name: "user"
    }), /*#__PURE__*/ React.createElement("span", {
        "data-t": "logged-out-greeting",
        className: "myaccount-menu-button__label"
    }, getLabel('account.menu.greeting.loggedOut'))), viewState === 'known-user' && /*#__PURE__*/ React.createElement(PersonalizedGreeting, {
        personalDetails: personalDetails,
        greetingFormatter: greetingFormatter
    }), viewState === 'loading' && /*#__PURE__*/ React.createElement(Loader, null)), /*#__PURE__*/ React.createElement(Flyout.Menu, null, menuItems.map((item)=>{
        var ref, ref1;
         return React.createElement(Flyout.MenuItem, {
            key: item.label,
            link: (ref = item.link) === null || ref === void 0 ? void 0 : ref.href,
            action: (ref1 = item.parameters) === null || ref1 === void 0 ? void 0 : ref1.action
        }, item.label);
    })));
};

const MyAccountMenuContainer = (props)=>{
    const auth = useSelector(getAuth);
    const userData = useSelector(getUserData) || uninitState();
    const [viewState, setViewState] = React.useState('loading');
    const [personalDetails, setPersonalDetails] = React.useState(getParsedDataFromLS);
    React.useEffect(()=>{
        const isAuthLoading = getLoggedInState(auth) === 'loading';
        if (isAuthLoading || statusLoading(userData)) {
            setViewState('loading');
        // If the user is logged in or if there are personal details in local storage.
        } else if (isLoggedIn$1(auth) || !!personalDetails) {
            setViewState('known-user');
            if (statusSuccess(userData)) {
                setPersonalDetails(userData.result.personalDetails);
                //todo: move this to a saga
                writeUserDataToLS(userData.result.personalDetails);
            }
        } else {
            setViewState('unknown-user');
        }
    }, [
        auth,
        userData
    ]);
    return /*#__PURE__*/ React.createElement(MyAccountMenu, swcHelpers.extends({}, props, {
        viewState: viewState,
        personalDetails: personalDetails
    }));
};

const AuthContext = /*#__PURE__*/ React.createContext({});
const AuthContextConsumer = ({ children  })=>/*#__PURE__*/ React.createElement(AuthContext.Consumer, null, (context)=>{
        if (!context || Object.keys(context).length === 0) {
            return /*#__PURE__*/ React.createElement("p", {
                className: "my-account--no-context"
            }, "Auth Provider missing in application.");
        }
        if (!context.enabled) {
            // TODO: instead redirect?
            return /*#__PURE__*/ React.createElement("p", {
                className: "my-account--not-enabled"
            }, "Auth not enabled in application.");
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    })
;

class Provider extends React.PureComponent {
    componentDidMount() {
        if (this.props.enabled) {
            this.props.init(this.props.settings);
        }
    }
    render() {
        const { enabled , children  } = this.props;
        const value = {
            enabled
        };
        return /*#__PURE__*/ React.createElement(AuthContext.Provider, {
            value: value
        }, children);
    }
}
const AuthProvider = (props)=>{
    const { isMyAccountEnabled  } = useFeatureToggles();
    const dispatch = useDispatch();
    const initWrapper = React.useCallback((settings)=>{
        dispatch(init$1(settings));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(Provider, swcHelpers.extends({}, props, {
        enabled: isMyAccountEnabled,
        init: initWrapper
    }));
};

const UNKNOWN = 'UNKNOWN';
const useAccount = ()=>{
    const dispatch = useDispatch();
    const auth = useSelector(getAuth);
    const currentlyInitialized = isInitialized$1(auth);
    useEffect(()=>{
        if (currentlyInitialized) {
            dispatch(recoverSession$1());
        }
    }, [
        currentlyInitialized
    ]);
    if (currentlyInitialized) {
        return UNKNOWN;
    }
    // "passwordless" logins will return false here
    if (isLoggedIn$1(auth)) {
        return AuthState.LoggedIn;
    }
    if (isLoggedInPasswordless(auth) || isParseHashFailed(auth) || isLoggedOut$1(auth)) {
        return AuthState.LoggedOut;
    }
    return UNKNOWN;
};

ReducersRegistry.register('auth', reducer);
SagaRegistry.register('auth', sagas);

export { actions as Actions, AuthContext, AuthContextConsumer, AuthProvider, Callback, index$1 as CreateAccount, ExpiredLink, LoggedIn$1 as LoggedIn, Login$1 as Login, MyAccountMenuContainer as MyAccountMenu, index as ResetPassword, RouteKey, selectors as Selectors, state as State, types as Types, index$2 as Utils, cacheToken, getMyAccountMenuItems, getToken, init$1 as init, optIns, useAccount, useAvailableOptIns, useOptIns };
//# sourceMappingURL=index.js.map
